export const allPlayerDataResponse = {
  data: [
    {
      _id: "6783165f85e349cd58353de8",
      playerId: 1001,
      playerName: "Sujit",
      playerNickName: "Patra",
      dob: "1977-09-29T00:00:00.000Z",
      weight: "84",
      height: "5.11",
      tShirtSize: "xxl",
      mobile: "7908484759",
      aadharId: "775543651281",
      address: "Tungi",
      district: "Bankura",
      state: "WB",
      pinCode: "722173",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/61993ca8-f63c-4b19-990d-aea34b843b85-1000036558.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/caccb30c-ec8f-4e34-affa-5427ff036bf1-Screenshot_20250112-063732_GPay.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6783165f85e349cd58353de9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6783361a338360b6ca2d3a3b",
      playerId: 1002,
      playerName: "TAPAS MAKUR",
      playerNickName: "SACHINIST",
      dob: "1994-06-10T00:00:00.000Z",
      weight: "55",
      height: "5",
      tShirtSize: "m",
      mobile: "8101345194",
      aadharId: "518872332966",
      address: "GOPIRHIR",
      district: "BANKURA",
      state: "WB",
      pinCode: "722155",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/fd6e65e5-976d-4a81-9753-d3ae194d1244-MY%20PHOTO.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d120f222-4fb5-4d29-8733-5de7f15a45b5-04e11044-d104-423e-aa20-ab8f1402d92e.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6783361a338360b6ca2d3a3c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678343683cdc341686cc446f",
      playerId: 1003,
      playerName: "Rappa Mukhi ",
      playerNickName: "Rappa",
      dob: "1990-12-17T00:00:00.000Z",
      weight: "80",
      height: "6 fit",
      tShirtSize: "xxl",
      mobile: "9635363246",
      aadharId: "973701534741",
      address: "sonamukhi",
      district: "bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d648ec7f-967f-4cad-9eb1-0ad144b79fe2-1000031809.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1642ee9a-ae17-448a-8198-706f10719f40-Screenshot_20250112_094512_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "",
          soldPrice: "",
          _id: "678343683cdc341686cc4470",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678347c7515b562cf980c17d",
      playerId: 1004,
      playerName: "Babai Bauri",
      playerNickName: "Babai ",
      dob: "1997-12-30T00:00:00.000Z",
      weight: "85",
      height: "5ft6",
      tShirtSize: "xl",
      mobile: "8918976093",
      aadharId: "810739483321",
      address: "Barjora",
      district: "Bankura",
      state: "WB",
      pinCode: "722142",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9618e0f3-2d9d-4b27-9a1f-dfbb0690af01-1000020897.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b11f0e17-babf-49dc-a49b-5d419bfa58fd-Screenshot_20250112_100223.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678347c7515b562cf980c17e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67839da483edc945c2f3b651",
      playerId: 1005,
      playerName: "TRIDIP KARMAKAR",
      playerNickName: "RINTU",
      dob: "1986-12-13T00:00:00.000Z",
      weight: "57",
      height: '5.5"',
      tShirtSize: "m",
      mobile: "8597975403",
      aadharId: "378317463488",
      address: "STATION PARA",
      district: "PURULIA",
      state: "WB",
      pinCode: ".723101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8587a866-3958-4ca2-b49a-db75af1fc2be-inbound6339660016537215341.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a8e769ef-af75-4239-8769-34dc08b28ace-inbound3789689342172665544.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67839da483edc945c2f3b652",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6783e063abbd6e1f740ea5cc",
      playerId: 1006,
      playerName: "SWARUP KARMAKAR",
      playerNickName: "Arjun",
      dob: "1998-04-12T00:00:00.000Z",
      weight: "60",
      height: "5ft   7inc",
      tShirtSize: "l",
      mobile: "7047911153",
      aadharId: "884865189642",
      address: "kashipur",
      district: "Purulia",
      state: "WB",
      pinCode: "723121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/961bafe9-304a-424a-aa1e-308e09f39c5d-1000023016.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/db92b20e-65f0-4606-8655-62ae79c29592-Screenshot_2025-01-12-20-47-38-599_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "",
          soldPrice: "",
          _id: "6783e063abbd6e1f740ea5cd",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6783f9c7776fad9b875ceeee",
      playerId: 1008,
      playerName: "Chandan mishra",
      playerNickName: "Chandan",
      dob: "1991-04-17T00:00:00.000Z",
      weight: "75",
      height: "5'11,\"",
      tShirtSize: "xl",
      mobile: "08670634940",
      aadharId: "638428920442",
      address: "Kalberia",
      district: "Bankura",
      state: "WB",
      pinCode: "722203",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d5cbdc5f-e3d9-472a-b93b-a8946536fc4c-IMG_6667~2.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/7067aa70-2024-4d0a-aa40-ba3bbb96c876-Screenshot_20250112-224519_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6783f9c7776fad9b875ceeef",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784ad446588f9f1f4680366",
      playerId: 1009,
      playerName: "Ganesh Sukla ",
      playerNickName: "Sukla ",
      dob: "1996-01-04T00:00:00.000Z",
      weight: "72",
      height: "5'9",
      tShirtSize: "l",
      mobile: "7501279078",
      aadharId: "340192466839",
      address: "Dulmi nadiha",
      district: "Purulia ",
      state: "Example State",
      pinCode: "723102",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      preferredJerseyNumber: "18",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c44a1309-027e-4f5b-9f18-f7e62fa4a72e-IMG_20250113_112257.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/dce037b5-5ac6-417e-81ce-ec7de8919b51-Screenshot_2025-01-13-11-11-06-15_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784ad446588f9f1f4680367",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784afa86588f9f1f468038d",
      playerId: 1010,
      playerName: "Indrajit Pal",
      playerNickName: "Rony",
      dob: "2010-01-03T00:00:00.000Z",
      weight: "59",
      height: "5.5",
      tShirtSize: "m",
      mobile: "9064095573",
      aadharId: "269766733687",
      address: "Barjora",
      district: "Bankura ",
      state: "Example State",
      pinCode: "722202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      preferredJerseyNumber: "18",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3109b4a1-0bbe-4166-8877-81a1256f4336-inbound1534440841018433255.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/eaad5e6f-8083-407b-8621-ac3e15e09f8c-inbound6633899198538156845.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784afa86588f9f1f468038e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784bf13a59c6b5f3f560cf4",
      playerId: 1011,
      playerName: "Biswajit Roy ",
      dob: "1996-06-10T00:00:00.000Z",
      weight: "76",
      height: "5.7",
      tShirtSize: "l",
      mobile: "8617476965",
      aadharId: "554874201511",
      address: "Jhalda",
      district: "Purulia ",
      state: "Example State",
      pinCode: "723202",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      preferredJerseyNumber: "18",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7638ae2d-8f75-40d4-b16d-cd2054e3d098-1000035552.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f630c4dd-d117-49d2-91ab-945980bf808e-Screenshot_20250113-124639.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784bf13a59c6b5f3f560cf5",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784c4c0a59c6b5f3f560d73",
      playerId: 1012,
      playerName: "Sounav Singha ",
      playerNickName: "Borka",
      dob: "1999-09-10T00:00:00.000Z",
      weight: "71",
      height: '5"5',
      tShirtSize: "l",
      mobile: "7908582288",
      aadharId: "628073449174",
      address: "Amarkanan",
      district: "Bankura",
      state: "Example State",
      pinCode: "722133",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      preferredJerseyNumber: "18",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d974314d-c315-474b-8caf-938443ace7a9-inbound1829777714625321051.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1f42fc6e-905e-4e9b-b145-2c6f6a6f391e-inbound6761285764837217216.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784c4c0a59c6b5f3f560d74",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784caad6cf08448a4f611e8",
      playerId: 1013,
      playerName: "Sanu Paramanik",
      playerNickName: "Sanu",
      dob: "1993-04-20T00:00:00.000Z",
      weight: "85",
      height: "5'10",
      tShirtSize: "xl",
      mobile: "7001570740",
      aadharId: "5473 9974 5196",
      address: "Kashipur",
      district: "Purulia",
      state: "Example State",
      pinCode: "723132",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      preferredJerseyNumber: "18",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/6c0c118f-32b6-4150-89b8-24be1e3ccd47-20240820_091526.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/aea4ba14-d903-4fa1-87ce-b05b28da6e00-Screenshot_2025-01-13-13-31-37-240_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784caad6cf08448a4f611e9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784cae16cf08448a4f611ee",
      playerId: 1014,
      playerName: "Akash Kuiri",
      playerNickName: "Aku",
      dob: "2006-08-13T00:00:00.000Z",
      weight: "72",
      height: "5'6",
      tShirtSize: "xl",
      mobile: "8101104472",
      aadharId: "870300778714",
      address: "kukurgoria",
      district: "Purulia",
      state: "Example State",
      pinCode: "723149",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      preferredJerseyNumber: "18",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/cd0fae1b-eb6a-4f86-8503-c14180e3537b-IMG_20241206_172255.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/699dcaea-179e-4b36-a09e-13789d67066b-Screenshot_2025-01-12-19-19-24-960_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784cae16cf08448a4f611ef",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784d2720b7d041f47a95040",
      playerId: 1015,
      playerName: "RAJIB DHIBAR ",
      playerNickName: "RAJIB ",
      dob: "1991-01-12T00:00:00.000Z",
      weight: "65",
      height: "5:5",
      tShirtSize: "m",
      mobile: "8250167039",
      aadharId: "614327602864",
      address: "Sonamukhi",
      district: "Bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/23066577-578d-435e-8471-d76cdaed9bc1-1000059183.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0299d6b7-bdbb-489d-bf85-6207dc403ce0-1728557333161.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784d2720b7d041f47a95041",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784d28c0b7d041f47a95046",
      playerId: 1016,
      playerName: "Ashish Mondal ",
      playerNickName: "Debu ",
      dob: "1993-01-27T00:00:00.000Z",
      weight: "79",
      height: "6ft",
      tShirtSize: "xl",
      mobile: "8389096501",
      aadharId: "622039363240",
      address: "Tiluri",
      district: "Bankura ",
      state: "WB",
      pinCode: "722153",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d995ccde-40d4-4059-a264-8d247b938eeb-20231224_175746.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/237b33e3-5d61-4c10-aeb1-ce8ebca7c9c7-Screenshot_20250113_141242_PhonePe.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784d28c0b7d041f47a95047",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784ee851b15a42082cba888",
      playerId: 1017,
      playerName: "Nabarun Ghorui ",
      playerNickName: "Ng jr ",
      dob: "1993-11-15T00:00:00.000Z",
      weight: "75",
      height: "5'9",
      tShirtSize: "xl",
      mobile: "6295551756",
      aadharId: "8740 7177 5751",
      address: "Barjora ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/85059af2-712a-431e-a989-827e4528a2fd-18eaafb0-dcfb-4f01-b8ae-516bc9ab3548-1_all_18.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0e829681-04c0-4388-a2f3-1ec5796fbb94-Screenshot_2025-01-13-15-58-58-17_62126bfb2f1f11d3d1500551279358f0.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784ee851b15a42082cba889",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6784f80b854ab85785369c93",
      playerId: 1018,
      playerName: "BIJOY DARIPA ",
      playerNickName: "CHINU",
      dob: "1988-10-21T00:00:00.000Z",
      weight: "78",
      height: "173 CM",
      tShirtSize: "xl",
      mobile: "9641927645",
      aadharId: "385509385977",
      address: "JHANTIPAHARI ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722137",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e3aacd26-b74d-447b-a8a9-c24b1e2f764f-1000104353.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/80e44b72-bba5-4386-982a-4a1f5392b3f1-IMG-20250112-WA0018%281%29.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6784f80b854ab85785369c94",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678500bd854ab85785369d25",
      playerId: 1019,
      playerName: "BIJOY DUTTA",
      playerNickName: "BIJOY",
      dob: "1991-04-20T00:00:00.000Z",
      weight: "62",
      height: '5.5"',
      tShirtSize: "l",
      mobile: "8670344835",
      aadharId: "783340354343",
      address: "Puncha",
      district: "PURULIA",
      state: "WB",
      pinCode: "723151",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9a3d5efd-3783-4254-ac8b-c27970520976-inbound4661635835457291610.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4e4779e1-1a4f-4694-9edd-723d39993400-inbound6850375501961585652.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678500bd854ab85785369d26",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67850720854ab85785369dd3",
      playerId: 1020,
      playerName: "Pranab Singha",
      playerNickName: "Bishal",
      dob: "2001-10-29T00:00:00.000Z",
      weight: "64",
      height: '5.8"',
      tShirtSize: "l",
      mobile: "9749116214",
      aadharId: "290932539690",
      address: "Amarkanan",
      district: "Bankura",
      state: "WB",
      pinCode: "722133",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/eb8331c1-be08-455d-9b22-c7e69d91feb9-1000064930.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4b7d12ab-1f36-4a22-8f61-7cf395cc16ee-IMG-20250113-WA0002.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67850720854ab85785369dd4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67850db6854ab8578536a01d",
      playerId: 1021,
      playerName: "Manas banerjee",
      playerNickName: "Mana",
      dob: "1983-05-03T00:00:00.000Z",
      weight: "82",
      height: "5ft 11 inch",
      tShirtSize: "xxl",
      mobile: "9932482466",
      aadharId: "338533320753",
      address: "Moshiara",
      district: "Bankura",
      state: "WB",
      pinCode: "722121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/6a85aa8f-b958-46b7-a964-78fa5286c1dc-IMG-20250113-WA0011.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d0ba9d10-70d8-4b14-bdb0-64fb31b15ec7-IMG-20250113-WA0010.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67850db6854ab8578536a01e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678521a9f90ffc4a0a839ce0",
      playerId: 1022,
      playerName: "Subha chatterjee",
      playerNickName: "Subha",
      dob: "1992-05-12T00:00:00.000Z",
      weight: "66",
      height: "5ft.7 inch.",
      tShirtSize: "l",
      mobile: "9134806794",
      aadharId: "822902002252",
      address: "chhandar",
      district: "Bankura",
      state: "WB",
      pinCode: "722203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/570ca742-9883-4512-a94f-46ea21600fb2-IMG_20240215_170556.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6bd6bb2a-a0d8-40c4-bfa8-d6542ecfa0f5-Screenshot_2025-01-13-19-45-13-071_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678521a9f90ffc4a0a839ce1",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678528055b7be2951b2160ac",
      playerId: 1023,
      playerName: "Gobinda Tantubay",
      playerNickName: "Gobinda",
      dob: "2002-04-10T00:00:00.000Z",
      weight: "61",
      height: '5"7',
      tShirtSize: "l",
      mobile: "8001576089",
      aadharId: "5285 6391 9875",
      address: "Raghunathpur",
      district: "Purulia",
      state: "WB",
      pinCode: "723121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b24dc130-ed2d-45f1-9832-489c91251a23-inbound8744730013458377361.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d2ec9d00-ad27-46d6-906f-8fe88655637f-inbound4651425152787736321.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678528055b7be2951b2160ad",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67852d838fb0e9cc2325fafe",
      playerId: 1024,
      playerName: "Subhadip chatterjee",
      playerNickName: "Bandhan",
      dob: "1991-04-28T00:00:00.000Z",
      weight: "78",
      height: "5ft 10 inches",
      tShirtSize: "xl",
      mobile: "8670843741",
      aadharId: "751777553547",
      address: "Moshiara",
      district: "Bankura",
      state: "WB",
      pinCode: "722121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/23ba8c38-f9e6-4270-ada4-549a7ef8aa01-1000137189.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1a3dca11-4e2e-4536-8072-906449fec30c-IMG-20250113-WA0027.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67852d838fb0e9cc2325faff",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6785cdbe77b715694de72d39",
      playerId: 1025,
      playerName: "ANUP SINGHA ",
      playerNickName: "Anup ",
      dob: "1996-01-01T00:00:00.000Z",
      weight: "68",
      height: "5.11",
      tShirtSize: "l",
      mobile: "9732823301",
      aadharId: "249668675331",
      address: "Barjora",
      district: "Bankura ",
      state: "WB",
      pinCode: "722202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/356a0de3-356d-4797-bc1d-e837713c764b-SAVE_20220504_161643.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/7161830e-9ca1-4521-872f-018946f553dd-Screenshot_2025-01-14-07-59-30-832_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6785cdbe77b715694de72d3a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6785e5b7fd34309fc485e546",
      playerId: 1026,
      playerName: "OSMAN MALLICK ",
      playerNickName: "OSMAN",
      dob: "1990-05-20T00:00:00.000Z",
      weight: "69",
      height: "5'-11\"",
      tShirtSize: "m",
      mobile: "9775644485",
      aadharId: "485168690219",
      address: "KATNA-BISHNUPUR",
      district: "BANKURA",
      state: "WB",
      pinCode: "722122",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/19dd6a9d-9448-487d-b647-97e9f073e05f-aed56472-8ecc-4294-906d-849815585146.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/17c0e5c2-d4f2-4ac2-959e-369a9e804162-4608a393-e0fc-4c50-94f2-1db37a362423.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6785e5b7fd34309fc485e547",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6785f34789f496975b2ac368",
      playerId: 1027,
      playerName: "AJAY DAS",
      playerNickName: "Das",
      dob: "1991-07-14T00:00:00.000Z",
      weight: "68",
      height: '5" 7',
      tShirtSize: "l",
      mobile: "8617054882",
      aadharId: "631597192982",
      address: "Deshuria",
      district: "Bankura",
      state: "WB",
      pinCode: "722133",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7ec6ea62-efd9-427c-883b-5f9c3e70bd6e-IMG-20241230-WA0097.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/14b5a59a-c513-4bbc-88dd-d17883deb386-Screenshot_2025-01-14-10-14-42-374_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6785f34789f496975b2ac369",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6786658fff62c1feffcfa6bf",
      playerId: 1028,
      playerName: "Sourab karmakar ",
      playerNickName: "Bali",
      dob: "2003-02-08T00:00:00.000Z",
      weight: "74",
      height: "5/9",
      tShirtSize: "xl",
      mobile: "7797339943",
      aadharId: "601156600143",
      address: "Adra",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/12a6f37d-cdd7-4b0c-b910-56519475448f-1000053309.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f7717303-21fd-4b31-9ad3-b5968834597f-Screenshot_2025-01-14-18-45-04-13_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6786658fff62c1feffcfa6c0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67866984ff62c1feffcfa701",
      playerId: 1029,
      playerName: "Surya pal ",
      dob: "2005-03-23T00:00:00.000Z",
      weight: "72",
      height: "5.9",
      tShirtSize: "xl",
      mobile: "8250317167",
      aadharId: "6432 4399 6404",
      address: "Sonamukhi ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/0ed8af4c-5786-4d86-8dd5-7769e1b22a11-IMG-20240428-WA0001.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4984940f-68b8-4301-97eb-1ec0c482bb7e-IMG-20240428-WA0001.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67866984ff62c1feffcfa702",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678679fa8cbb3b51e8856a73",
      playerId: 1030,
      playerName: "AKSHOY SARKAR ",
      playerNickName: "AKSHOY ",
      dob: "1997-04-28T00:00:00.000Z",
      weight: "77",
      height: "5'6\"",
      tShirtSize: "l",
      mobile: "7003665827",
      aadharId: "805773174568",
      address: "Sonamukhi",
      district: "Bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/410664a5-d32f-45a1-af4f-77b586b78fb0-IMG_104209_14125.jpeg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6dc64774-c497-4c5a-acca-8739d33a7ecb-Screenshot_2025_0114_201654.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678679fa8cbb3b51e8856a74",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6786831e8cb60b941719bcf3",
      playerId: 1031,
      playerName: "SARBOJIT HAZRA",
      playerNickName: "BUNTY",
      dob: "1990-01-01T00:00:00.000Z",
      weight: "63",
      height: '5.5"',
      tShirtSize: "l",
      mobile: "8250228798",
      aadharId: "596060263486",
      address: "LOCOSHED PARA",
      district: "PURULIA",
      state: "WB",
      pinCode: "723103",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d7388f37-f663-4b5a-86c8-1ca7ac4bfeca-IMG_20250114_204956.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/95b130d7-80e4-4725-b8c7-9f7a885934d3-Screenshot_20250114_205557.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6786831e8cb60b941719bcf4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67871d2c877f9881b910003e",
      playerId: 1032,
      playerName: "Bimal Mahato",
      playerNickName: " Bini",
      dob: "2000-01-16T00:00:00.000Z",
      weight: "60",
      height: "5.3",
      tShirtSize: "m",
      mobile: "6295230219",
      aadharId: "273986893690",
      address: "Jhalda",
      district: "Purulia ",
      state: "WB",
      pinCode: "723202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/62f4d3c4-25e0-46fd-beeb-680382c01967-inbound7056780897811825730.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/dc89a081-35c9-4b40-9d77-8954f86219c8-inbound8638101691709426272.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67871d2c877f9881b910003f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67872948796c6a87b671f22c",
      playerId: 1033,
      playerName: "Rupesh Chatterjee",
      playerNickName: "Chotu",
      dob: "2004-09-19T00:00:00.000Z",
      weight: "50",
      height: "5.6",
      tShirtSize: "m",
      mobile: "0954 734 3161",
      aadharId: "314196373322",
      address: "Junbedia",
      district: "Bankura",
      state: "WB",
      pinCode: "722155",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/fba3782e-b5e9-4dd6-8ab0-80ea4fc69b6e-inbound1723979825215822656.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e2f84c8e-9678-40c2-af88-13aa77560eb1-Screenshot_2025-01-15-08-42-15-56_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67872948796c6a87b671f22d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6787514b2da4e637133fc654",
      playerId: 1034,
      playerName: "Samiran Rajak",
      playerNickName: "RANA",
      dob: "1994-11-06T00:00:00.000Z",
      weight: "74 kg ",
      height: "170 cm",
      tShirtSize: "xl",
      mobile: "7384766691",
      aadharId: "296138856345",
      address: "Chhatna ",
      district: "Bankura",
      state: "WB",
      pinCode: "722132",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c238ba3e-f7ae-442c-8d14-bb6920804a42-1000029630.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/db3641b8-fa1f-468c-ab37-a2bb22fdbcb7-Screenshot_20250115_112950_GPay.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6787514b2da4e637133fc655",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6787ea693bac6c6b4c16c2a5",
      playerId: 1035,
      playerName: "Bapi",
      playerNickName: "RAJAK",
      dob: "1986-05-12T00:00:00.000Z",
      weight: "67",
      height: "5'7\"",
      tShirtSize: "xl",
      mobile: "7319080576",
      aadharId: "686878692101",
      address: "supur-khatra",
      district: "Bankura",
      state: "WB",
      pinCode: "722140",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/23248ef6-3b33-4b93-97ee-9ba856864b72-20250115_221052.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a3f2f444-a4e3-4ab1-87d0-4f2df5d3f210-Screenshot_20250115_221621_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6787ea693bac6c6b4c16c2a6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6787eb0b3bac6c6b4c16c2ab",
      playerId: 1036,
      playerName: "Sk Suman Hossion ",
      playerNickName: "Hossion ",
      dob: "1999-09-04T00:00:00.000Z",
      weight: "52",
      height: "5.9",
      tShirtSize: "m",
      mobile: "7001808675",
      aadharId: "567486699447",
      address: "Bishnupur",
      district: "Bankura",
      state: "WB",
      pinCode: "722122",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/dd79612c-5caa-4ee8-874b-193f3f2aacea-1000005059.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e5b82933-35ff-4e30-95b3-f5b62cdf89e6-Screenshot_2025-01-15-22-28-45-57_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6787eb0b3bac6c6b4c16c2ac",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6788845bcc8ced252d6a0d84",
      playerId: 1037,
      playerName: "Sanjoy Mahato",
      playerNickName: "Sanju",
      dob: "1993-11-02T00:00:00.000Z",
      weight: "69 Kg",
      height: "723101",
      tShirtSize: "l",
      mobile: "6295296470",
      aadharId: "904774130948",
      address: "Raghabpur",
      district: "Purulia",
      state: "WB",
      pinCode: "723101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5e9bac57-b134-46cd-91ab-09ae7826c9bd-inbound606894324106908296.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/689db486-239c-4895-8b96-1516626db107-inbound1965461220694964195.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6788845bcc8ced252d6a0d85",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67889d90eb42efb2301f614c",
      playerId: 1038,
      playerName: "Rana mitra",
      playerNickName: "Lefty rana",
      dob: "2005-01-06T00:00:00.000Z",
      weight: "65",
      height: "5.4",
      tShirtSize: "m",
      mobile: "6295426445",
      aadharId: "4908 2268 8461",
      address: "Patrasayer",
      district: "Bankura",
      state: "WB",
      pinCode: "722206",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/69d883a4-52ad-40d2-ab51-f4d56aa4d6f1-1732535456960.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6e5f089c-f1ea-43e6-ab03-5f995c9c7fb9-Screenshot_2025-01-16-11-06-11-799_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67889d90eb42efb2301f614d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6788d822aee3539844a4b796",
      playerId: 1039,
      playerName: "ARJUN GORAIN ",
      dob: "1995-02-01T00:00:00.000Z",
      weight: "68",
      height: "5.7",
      tShirtSize: "l",
      mobile: "8617374283",
      aadharId: "388620796654",
      address: "ANARA ",
      district: "Purulia ",
      state: "WB",
      pinCode: "723126",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9d4cd068-748d-4b3e-860f-f6340f24b1e7-IMG-20250114-WA0039.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d9631d03-1b29-4362-8eaf-bbe231abd1ee-Screenshot_2025-01-16-15-26-18-88_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6788d822aee3539844a4b797",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678a53a42212f8e95261ceaa",
      playerId: 1040,
      playerName: "AVIJIT PAL",
      playerNickName: "Avi",
      dob: "1998-02-09T00:00:00.000Z",
      weight: "75",
      height: "5'9''",
      tShirtSize: "l",
      mobile: "9064010699",
      aadharId: "898056050064",
      address: "BARJORA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b8ce36ff-388a-4566-95d9-6242eec9f4fe-1000191193.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/bc5c44be-5a3d-4474-b2c6-404cf93f0b5e-Screenshot_20250117_181504_GPay.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678a53a42212f8e95261ceab",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678ba5ea136aaacdfe56959b",
      playerId: 1041,
      playerName: "Nil Dey ",
      dob: "2006-09-26T00:00:00.000Z",
      weight: "74",
      height: "6",
      tShirtSize: "xl",
      mobile: "9907612513",
      aadharId: "964291042841",
      address: "Sonamukhi ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/46ac4c1f-8516-4753-a8bb-742f7464af9a-IMG_20250118_182328.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e9580c86-f7aa-4ed3-ade4-ef22b9fe9d62-Screenshot_2025-01-18-18-28-56-923_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678ba5ea136aaacdfe56959c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678baef4ba2942ca7612ce11",
      playerId: 1042,
      playerName: "Subhadeep Mondal ",
      playerNickName: "Subha ",
      dob: "2000-10-21T00:00:00.000Z",
      weight: "72",
      height: "5.11 ",
      tShirtSize: "l",
      mobile: "7001656540",
      aadharId: "249861897478",
      address: "BELIATORE",
      district: "Bankura ",
      state: "WB",
      pinCode: "722203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3eaaa9fb-4121-44aa-8743-9f70d7f2cd73-IMG_20250118_190741.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8a006cf1-f790-4396-be92-2fac4664cadc-IMG-20250117-WA0051.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678baef4ba2942ca7612ce12",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678c8ca73955081b91abf1cf",
      playerId: 1043,
      playerName: "Subhadip Patra",
      playerNickName: "Subha",
      dob: "1998-03-16T00:00:00.000Z",
      weight: "85",
      height: "6'-3\"",
      tShirtSize: "xl",
      mobile: "9679622056",
      aadharId: "503716612153",
      address: "SIMLAPAL",
      district: "BANKURA",
      state: "WB",
      pinCode: "722151",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/55e27437-ba6e-4af3-a560-d15e7e524b9e-ac0b7343-88e7-4f6a-8e2a-e0365131b870.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1aa3dbff-a87d-41e8-a93b-1e317216585a-75454749-b9c6-42f7-8150-f880a8c789af.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678c8ca73955081b91abf1d0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678c97dea84b37354404ef1d",
      playerId: 1044,
      playerName: "Sumit karmakar ",
      playerNickName: "Sumit ",
      dob: "1987-01-16T00:00:00.000Z",
      weight: "75",
      height: "5.11",
      tShirtSize: "xl",
      mobile: "9932654754",
      aadharId: "351955899656",
      address: "Adra",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/755a5a54-351d-4e0b-9ad1-c412899b2c91-1000116022.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/92366405-dd63-4db2-964d-26872248c7b3-Screenshot_20250118_134312.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678c97dea84b37354404ef1e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678d29bbc11d432c541b21c8",
      playerId: 1045,
      playerName: "Ajoy Das ",
      playerNickName: "Jyoti ",
      dob: "2001-04-28T00:00:00.000Z",
      weight: "54",
      height: "5.3ft",
      tShirtSize: "m",
      mobile: "6296392579",
      aadharId: "290889591762",
      address: "School Danga",
      district: "Bankura ",
      state: "WB",
      pinCode: "722101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a01c3420-46f5-491e-bd4c-4ea27ac5f58d-IMG_20250119_215831.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a65ad882-beb1-4e75-94aa-131c513a78e6-IMG-20250119-WA0006.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678d29bbc11d432c541b21c9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678d2c98c11d432c541b21ce",
      playerId: 1046,
      playerName: "Manoj das ",
      playerNickName: "Manoj das ",
      dob: "2001-11-11T00:00:00.000Z",
      weight: "50",
      height: "5fut 4",
      tShirtSize: "l",
      mobile: "8101083304",
      aadharId: "31612741p186",
      address: "School danga",
      district: "Bankura ",
      state: "WB",
      pinCode: "722101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/12f217fb-0f9d-46b7-a8af-593a928d1cd4-1736856363381.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/462a80c1-cc8c-4984-aa91-5fca2dc70a0b-IMG-20250119-WA0006.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678d2c98c11d432c541b21cf",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678dcba0d09d58b14904c685",
      playerId: 1047,
      playerName: "Prince Murmu ",
      playerNickName: "Prince ",
      dob: "2008-08-06T00:00:00.000Z",
      weight: "75",
      height: "5'5''",
      tShirtSize: "xxl",
      mobile: "6297290047",
      aadharId: "728407601945",
      address: "Khatra",
      district: "Bankura ",
      state: "WB",
      pinCode: "722140",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f11f11ac-e96c-4406-b2d8-1d07512249d2-inbound3274009665221822224.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/646ef0dd-65e1-4e00-b848-5c3ced11ef03-inbound4905697421287363663.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678dcba0d09d58b14904c686",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678dd1f311d9fed6a9926fe5",
      playerId: 1048,
      playerName: "Snehashis Das",
      playerNickName: "BICHHU",
      dob: "1998-03-05T00:00:00.000Z",
      weight: "67",
      height: "5'-5\"",
      tShirtSize: "l",
      mobile: "6294100664",
      aadharId: "356871377688",
      address: "Ghutgoria",
      district: "BANKURA",
      state: "WB",
      pinCode: "722168",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ace1b9fe-1e3a-4686-bd2e-01dc4bc91b07-bc.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f77b3138-b544-4893-bf37-967dfcc9fd48-bicchu.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678dd1f311d9fed6a9926fe6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678ddb8e1904ecdda2c001d5",
      playerId: 1049,
      playerName: "SURAJ SHARMA",
      playerNickName: "RIJU",
      dob: "2000-12-24T00:00:00.000Z",
      weight: "65",
      height: "5.6",
      tShirtSize: "m",
      mobile: "6296870751",
      aadharId: "747757285849",
      address: "SONAMUKHI ",
      district: "Bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5cc3b266-ba68-42e0-be22-38e52a998dc2-inbound8808643138798471178.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f1dab03c-f8e4-4a2e-b067-d20df480a9ae-inbound1055940111071118744.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678ddb8e1904ecdda2c001d6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678ddd9a1904ecdda2c002aa",
      playerId: 1050,
      playerName: "Som chattaraj ",
      playerNickName: "Som",
      dob: "1996-12-23T00:00:00.000Z",
      weight: "68 ",
      height: "5'10\"",
      tShirtSize: "l",
      mobile: "8945855356",
      aadharId: "777399045833",
      address: "Godardihi",
      district: "Bankura ",
      state: "WB",
      pinCode: "722203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4ae6a7c6-eecb-4483-b742-5c143594206b-33e0310a-3cfe-4ced-8959-b233fa146b44-1_all_54.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/906b317f-118c-4224-8815-ea7cc3708dd0-Screenshot_2025-01-20-10-48-12-48_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678ddd9a1904ecdda2c002ab",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678e0ee37d1df754458e33b5",
      playerId: 1051,
      playerName: "Tabrej Alam ",
      playerNickName: "Tabrej ",
      dob: "1997-10-13T00:00:00.000Z",
      weight: "83kg",
      height: "6ft",
      tShirtSize: "xl",
      mobile: "7001674824",
      aadharId: "920340930710",
      address: "Anara",
      district: "Purulia ",
      state: "WB",
      pinCode: "723126",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ff204338-9d83-4da6-aacb-3ba94c0ef9d2-1000031082.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f89ae315-cf7d-4ad9-a649-ccf882ab55a9-IMG-20250120-WA0003%281%29.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678e0ee37d1df754458e33b6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678e675e5d5919c1b62d90a0",
      playerId: 1052,
      playerName: "sudip Kumar majee ",
      dob: "2004-04-23T00:00:00.000Z",
      weight: "56 kg",
      height: "165 cm",
      tShirtSize: "m",
      mobile: "8637363574",
      aadharId: "223595138309",
      address: "Kashipur",
      district: "purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2dedb17c-941d-4c05-89c3-83840d9430d3-IMG_20241214_184557.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f7e2a593-9487-48c9-b807-dec21c3bd347-Screenshot_2025-01-20-20-25-27-20_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678e675e5d5919c1b62d90a1",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678f13a720ac7b2a42883696",
      playerId: 1053,
      playerName: "Arup Kumar Senapati ",
      playerNickName: "Babu",
      dob: "1992-01-12T00:00:00.000Z",
      weight: "88",
      height: "6.2",
      tShirtSize: "xl",
      mobile: "8944905973",
      aadharId: "601097019790",
      address: "Indrabil",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8fe6ce6b-f393-4640-a9ff-455188138272-inbound4816702496178788557.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/73c7193b-88d5-4e0a-a686-e2c9b4e4418e-inbound9078111573279969828.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678f13a720ac7b2a42883697",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678f1ccb429d7c19fe60ba5d",
      playerId: 1054,
      playerName: "AFJAL ANSARY",
      playerNickName: "AFJAL",
      dob: "1995-03-05T00:00:00.000Z",
      weight: "65",
      height: '5.5"',
      tShirtSize: "m",
      mobile: "9113413152",
      aadharId: "330403226469",
      address: "KUTIDIH",
      district: "PURULIA",
      state: "WB",
      pinCode: "723202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/90c0ce5a-ed24-4a35-a2a5-04f4475d1917-inbound7755873883797921925.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/c82ff1fe-c1c6-48f8-988a-9568e660670d-inbound8634681725945222668.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678f1ccb429d7c19fe60ba5e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678f2950950204caba7d3b15",
      playerId: 1055,
      playerName: "SANTANU DAS",
      playerNickName: "Santanu",
      dob: "1998-12-21T00:00:00.000Z",
      weight: "70 kg",
      height: "5 feet 7 inch",
      tShirtSize: "m",
      mobile: "9064426373",
      aadharId: "483404303022",
      address: "BISHNUPUR ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722122",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5f6d0229-f0c7-45fd-bcc7-5703ea3475f7-inbound3611759835012374005.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a487d91b-0c23-4f40-94d0-99a9fc009119-inbound2190352425105757569.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678f2950950204caba7d3b16",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678f78bc5bafd48e2f57811b",
      playerId: 1056,
      playerName: "JAGANNATH DUTTA",
      playerNickName: "Boom",
      dob: "1993-03-21T00:00:00.000Z",
      weight: "70",
      height: "5.6",
      tShirtSize: "xl",
      mobile: "7001244118 ",
      aadharId: "932495837204",
      address: "Manbazar",
      district: "PURULIA",
      state: "WB",
      pinCode: "723131",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/971e9098-7b15-4128-a3aa-c9a579ea84de-JDutta.jpeg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/81b4e2ec-37d8-4a61-9436-683b161bab45-Jagannath.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678f78bc5bafd48e2f57811c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678fb83c8bd9cd78cc7ec892",
      playerId: 1057,
      playerName: "BISHNU BOURI ",
      dob: "1994-08-12T00:00:00.000Z",
      weight: "72",
      height: "5,ft 6 inch ",
      tShirtSize: "xl",
      mobile: "8972430011",
      aadharId: "267678856743",
      address: "Bongabari",
      district: "PURULIA ",
      state: "WB",
      pinCode: "723147",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1e3f2ba8-6abf-48c0-817d-b70f239f24b6-BISHNU.JPG",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/2bbc9039-9a3c-4202-97fe-5ecb810f23bf-Screenshot_2025-01-21-20-25-51-18_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678fb83c8bd9cd78cc7ec893",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "678fc491ff618ccf4f1ac450",
      playerId: 1058,
      playerName: "SOURAV MONDAL ",
      playerNickName: "Chutu",
      dob: "1997-01-01T00:00:00.000Z",
      weight: "62",
      height: "5 feet 6 inch",
      tShirtSize: "m",
      mobile: "6296323878",
      aadharId: "8699 9669 9795",
      address: "BISHNUPUR ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722164",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a1c7bdb2-c7a8-4230-a312-502685d6b3c9-inbound522168128982435472.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4a046984-1398-4108-9498-af622af96540-inbound8149291090530672871.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "678fc491ff618ccf4f1ac451",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67908e8a1667c6e8b653af80",
      playerId: 1060,
      playerName: "Tapas sarkar",
      playerNickName: "Tapas",
      dob: "1984-01-10T00:00:00.000Z",
      weight: "75",
      height: "5 fet 6 inch",
      tShirtSize: "xl",
      mobile: "9547022466",
      aadharId: "519286027140",
      address: "Sonamukhi",
      district: "Bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/98a077bd-8e76-46c6-a825-c9a7f8e0097a-17375268983733178426234858929547.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6c2f2dc5-d523-417f-a3fe-50c628b76b5f-IMG-20250122-WA0003.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67908e8a1667c6e8b653af81",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6790936e5cf1a51eb5df85ac",
      playerId: 1061,
      playerName: "Subhendu Mukherjee ",
      playerNickName: "Raja",
      dob: "1999-04-07T00:00:00.000Z",
      weight: "72",
      height: '5.7"',
      tShirtSize: "l",
      mobile: "8617529800",
      aadharId: "391784001600",
      address: "MTPS DVC ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722183",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/115f800f-7a29-4aac-b107-f784e8c25d79-IMG-20241229-WA0050.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/baef71d0-4f96-464a-8c10-f450b3821327-Screenshot_20250122_120451.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6790936e5cf1a51eb5df85ad",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679098635cf1a51eb5df85fa",
      playerId: 1062,
      playerName: "RATHIKANTA DAS",
      playerNickName: "RATHIKANTA",
      dob: "2000-02-25T00:00:00.000Z",
      weight: "63",
      height: "5'-6\"",
      tShirtSize: "m",
      mobile: "7047780623",
      aadharId: "268171204765",
      address: "Dighi-Hirbandh ",
      district: "Bankura",
      state: "WB",
      pinCode: "722121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7065c754-28e1-4e5f-88c1-4d3b60f3da8e-rathi-2.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5ecbe7c7-b2f8-4bb5-b884-6881fd75ad80-rathi.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679098635cf1a51eb5df85fb",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6791c8d0232596635ade8d22",
      playerId: 1063,
      playerName: "Mohit Mohta",
      playerNickName: "Mohit",
      dob: "1995-10-19T00:00:00.000Z",
      weight: "90",
      height: "5'11",
      tShirtSize: "xxl",
      mobile: "8972554016",
      aadharId: "357291358823",
      address: "Ganja Gali-Chaibasa road,",
      district: "Purulia",
      state: "WB",
      pinCode: "723101",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "offSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a02eb4f6-e693-4e3a-a96c-62188586f86b-1000000874.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/acc12cf1-1750-4a45-a7b7-cbdbda774823-Screenshot_20250123_100922_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6791c8d0232596635ade8d23",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6791d82f04f76ad2a87386f1",
      playerId: 1064,
      playerName: "RAJESH CHATTERJEE",
      playerNickName: "RAJU",
      dob: "1995-03-24T00:00:00.000Z",
      weight: "76",
      height: "6'1",
      tShirtSize: "xl",
      mobile: "8016280905",
      aadharId: "748177866987",
      address: "BEGUNKODAR",
      district: "PURULIA",
      state: "WB",
      pinCode: "723202",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/02ffdb97-b684-4924-bbfc-81080ac191da-inbound9092490788669196540.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9503146f-d337-4265-a6d6-6ec3d9fe1cb1-inbound4904043126768617434.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6791d82f04f76ad2a87386f2",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6791d8f004f76ad2a87386f7",
      playerId: 1065,
      playerName: "Adarsha Ganguli ",
      playerNickName: "Adi",
      dob: "2008-01-18T00:00:00.000Z",
      weight: "50",
      height: "5 feet 6 inch",
      tShirtSize: "m",
      mobile: "9332949819",
      aadharId: "226549107281",
      address: "Karpur bagan",
      district: "Purulia ",
      state: "WB",
      pinCode: "723101",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b68b707b-3c90-4ae6-a0f7-edaa0669e048-IMG-20240808-WA0002.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/fe088cd9-9760-4e3c-8dfd-c73e2c766acf-Screenshot_2025-01-23-11-18-06-30_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6791d8f004f76ad2a87386f8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67920b82ebf2fd573e76f5fd",
      playerId: 1066,
      playerName: "Rakhahari karmakar",
      playerNickName: "RAKHU",
      dob: "1989-04-11T00:00:00.000Z",
      weight: "75",
      height: "5 ft 6 ",
      tShirtSize: "l",
      mobile: "9064073947",
      aadharId: "797739156938",
      address: "Bankdaha",
      district: "Bankura",
      state: "WB",
      pinCode: "722133",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/daddd780-7ab9-4374-9bca-840cd825518f-1000543643.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cc9502cd-4ffc-4da6-9934-00e8e3352a3f-Screenshot_20250123_144835.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67920b82ebf2fd573e76f5fe",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679217eebdd2b2da8cb11d77",
      playerId: 1067,
      playerName: "NEEL MAHANTA",
      playerNickName: "NEEL",
      dob: "2005-12-19T00:00:00.000Z",
      weight: "60",
      height: "5.6FT",
      tShirtSize: "m",
      mobile: "9641122667",
      aadharId: "924449120417",
      address: "ONDA",
      district: "Bankura",
      state: "WB",
      pinCode: "722152",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/544fee22-4e30-4784-ba62-a6d5f9663b61-scl.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9efb7569-dcef-406a-b5f2-b6ad8c65fd4f-WhatsApp%20Image%202025-01-23%20at%2015.44.21_92a41b4f.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679217eebdd2b2da8cb11d78",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679250f0954286046f070319",
      playerId: 1068,
      playerName: "Tapajoti Bauri",
      playerNickName: "Tufan bauri",
      dob: "2005-09-15T00:00:00.000Z",
      weight: "57 kg",
      height: "5 fit",
      tShirtSize: "l",
      mobile: "9339618574",
      aadharId: "603727707547",
      address: "Laulara",
      district: "Purulia ",
      state: "WB",
      pinCode: "723151",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2fd157a9-4799-4277-905f-e95d467d0284-1000314675.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4b8aa800-eb63-4272-8511-2bac46a5069f-Screenshot_2025-01-23-19-51-39-41_4336b74596784d9a2aa81f87c2016f50.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679250f0954286046f07031a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6792735b7d9f501b83e3b6dc",
      playerId: 1069,
      playerName: "SANTOSH RAM",
      playerNickName: "SANTOSH",
      dob: "1988-11-25T00:00:00.000Z",
      weight: "57",
      height: '5.6"',
      tShirtSize: "m",
      mobile: "8436695210",
      aadharId: "731036967874",
      address: "DESHBANDHU ROAD",
      district: "PURULIA",
      state: "WB",
      pinCode: "723101",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e48f3128-c92b-43d3-9595-9d601cc2d476-1000259415.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/26a0a4b0-5ce1-46ed-b717-589e2d631046-Screenshot_2025-01-23-22-10-25-256_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6792735b7d9f501b83e3b6dd",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6792df45f9368a552a073234",
      playerId: 1070,
      playerName: "Rahul Mahato ",
      dob: "2000-05-17T00:00:00.000Z",
      weight: "76kg",
      height: "5.6feet",
      tShirtSize: "l",
      mobile: "9749553341",
      aadharId: "451180439251",
      address: "Bandwan",
      district: "Purulia ",
      state: "WB",
      pinCode: "723129",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/27ca9c68-8644-4238-94e0-0ff417817e82-1000546728.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/2146bd1f-aa65-41b9-8df6-f4fd5375ef9e-Screenshot_20250124_055347.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6792df45f9368a552a073235",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6793290cb005dd02ddf8d862",
      playerId: 1071,
      playerName: "Nimai Mahatha",
      playerNickName: "NimP",
      dob: "1993-05-25T00:00:00.000Z",
      weight: "78kg",
      height: "06ft",
      tShirtSize: "l",
      mobile: "8637309637",
      aadharId: "2900 5818 2487",
      address: "Joradih",
      district: "Purulia",
      state: "WB",
      pinCode: "723145",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f54114f2-54d8-4841-b0b4-a30a9a7a80f3-Document%20from%20NimP%20Mahatha",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cf6c460b-ae17-495f-89e7-dd7e6f7dd3b4-Screenshot_20250124_110622_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6793290cb005dd02ddf8d863",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6793706cf07d5fc28aa8eebb",
      playerId: 1072,
      playerName: "Kartick Gorai ",
      playerNickName: "Sanjay",
      dob: "1994-05-02T00:00:00.000Z",
      weight: "5.10",
      height: "65",
      tShirtSize: "l",
      mobile: "6294478075",
      aadharId: "5195-7900-2648",
      address: "Tiluri",
      district: "Bankura ",
      state: "WB",
      pinCode: "722153",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/37f60bde-b74f-4b53-b380-070a194e78bd-IMG-20241230-WA0007.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b0c2d1ea-b025-49ac-9dcc-8ddd27bbb89a-Screenshot_20250124_160926.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6793706cf07d5fc28aa8eebc",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679379242960661f5d9ea984",
      playerId: 1073,
      playerName: "BITTU PANDEY",
      playerNickName: "Bittu",
      dob: "2004-06-24T00:00:00.000Z",
      weight: "65",
      height: "5.9",
      tShirtSize: "l",
      mobile: "8670769790",
      aadharId: "473936360602",
      address: "Imondi",
      district: "Purulia",
      state: "WB",
      pinCode: "723103",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/15fa97d8-098f-487f-8971-91d58d6d4701-Video.Guru_20241203-075708270.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4eb3396b-c860-441c-92e1-485bf8e61c39-Screenshot_2025-01-24-16-54-08-544_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679379242960661f5d9ea985",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67939cd97669654a9107393c",
      playerId: 1074,
      playerName: "Indranil Singha Deo",
      playerNickName: "Mana",
      dob: "1997-02-01T00:00:00.000Z",
      weight: "68",
      height: "5.4",
      tShirtSize: "l",
      mobile: "8967398191",
      aadharId: "678504057526",
      address: "Ghorabandha",
      district: "Purulia ",
      state: "WB",
      pinCode: "723152",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/40140063-a3e0-40a2-a6a5-d74ffa7cbdb0-IMG_20241006_221250_445.webp",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/878c2073-7d48-43ad-bd09-620c01ac30fa-Screenshot_2025-01-24-19-26-05-95_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67939cd97669654a9107393d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6793a2ee7669654a91073a72",
      playerId: 1075,
      playerName: "RABEN SINGH SARDAR",
      playerNickName: "RABEN",
      dob: "1992-01-12T00:00:00.000Z",
      weight: "8",
      height: "5",
      tShirtSize: "l",
      mobile: "9002245664",
      aadharId: "349626425871",
      address: "BERADA BARABAZAR",
      district: "PURULIA",
      state: "WB",
      pinCode: "723143",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/fdaf8468-f921-4b07-8ed8-788d81a96dfa-DSC_0926.JPG",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/63bf573e-03fa-495a-bf42-6c990bb0d59d-Screenshot_2025-01-24-19-50-38-424_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6793a2ee7669654a91073a73",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6794c9185642bf25ae5d13a7",
      playerId: 1076,
      playerName: "Totan mukherjee",
      playerNickName: "Dolan",
      dob: "1994-05-03T00:00:00.000Z",
      weight: "74kg",
      height: "5 fit 8 inch",
      tShirtSize: "l",
      mobile: "7908776948",
      aadharId: "579699392083",
      address: "Tiluri",
      district: "Bankura ",
      state: "WB",
      pinCode: "722153",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f79e0eed-fabb-486f-b75e-f847b9a6f89a-inbound240225984296094408.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/13a06fd8-d1a1-4f94-be35-c8a0024be45f-inbound9019485060742389634.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6794c9185642bf25ae5d13a8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6794d6afd7931c4e4c84c23a",
      playerId: 1077,
      playerName: "Probir chand ",
      playerNickName: "Dabla",
      dob: "1995-03-18T00:00:00.000Z",
      weight: "68",
      height: '5.8"',
      tShirtSize: "xl",
      mobile: "7908966076",
      aadharId: "896515064409",
      address: "Anara",
      district: "Purulia ",
      state: "WB",
      pinCode: "723126",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9edb18ab-5e4b-4b2a-a80f-125cb5197896-IMG_20210201_192809.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/7d6eed09-caad-4ce0-a08c-fff8259e55ad-Screenshot_2025-01-25-13-48-45-632_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6794d6afd7931c4e4c84c23b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6794f6de58f9324ff6dc193e",
      playerId: 1078,
      playerName: "Sanjoy sing sardar ",
      playerNickName: "Sanju",
      dob: "2003-10-17T00:00:00.000Z",
      weight: "75",
      height: '5"11',
      tShirtSize: "xxl",
      mobile: "8388910557",
      aadharId: "7512 9546 2565",
      address: "Mukutmanipur ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722140",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1c53e445-49c5-4ad5-96b7-e0bd5f65e925-IMG_20250125_200256.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/95a47115-2d7a-47ff-a19f-74829d8b09ba-IMG-20250125-WA0002.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6794f6de58f9324ff6dc193f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6795e12d4409146801181bd1",
      playerId: 1079,
      playerName: "Milan Khan",
      dob: "1995-05-12T00:00:00.000Z",
      weight: "70",
      height: "5'7\"",
      tShirtSize: "l",
      mobile: "8653161267",
      aadharId: "200731907695",
      address: "Durlovpur",
      district: "Bankura",
      state: "WB",
      pinCode: "722133",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4d4d6c0a-cde4-4131-83f3-733d233d6817-1000050997.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/99d9439c-1a12-4e4d-9de2-7331d68007e7-Screenshot_20250126-124226.PhonePe.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6795e12d4409146801181bd2",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6795e762e723e1f30746bbf3",
      playerId: 1080,
      playerName: "RAHUL ROY",
      playerNickName: "HITMAN ",
      dob: "1988-04-08T00:00:00.000Z",
      weight: "75",
      height: "5'9\"",
      tShirtSize: "m",
      mobile: "9679641819",
      aadharId: "843286635360",
      address: "NARAYANPUR",
      district: "PURULIA ",
      state: "WB",
      pinCode: "723121",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d4def738-0659-4895-8bd0-25283d1dcb48-inbound7943358930824989451.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b557b75f-95bc-4103-9f2b-7b08f299fda2-inbound133711121119498571.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6795e762e723e1f30746bbf4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67963b8ef2bb2fa6fa1b2a11",
      playerId: 1081,
      playerName: "UJJWAL MUKHERJEE ",
      playerNickName: "UJJWAL",
      dob: "1986-03-15T00:00:00.000Z",
      weight: "82",
      height: "5'10\"",
      tShirtSize: "xl",
      mobile: "9635050399",
      aadharId: "931129218271",
      address: "GARHJOYPUR",
      district: "PURULIA ",
      state: "WB",
      pinCode: "723201",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7aee7345-70bb-4c10-847b-8138123e9d3e-inbound3670949607586942625.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/88849558-fb19-4d38-a9cb-4f19db0601fe-inbound8031320218070957605.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67963b8ef2bb2fa6fa1b2a12",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679659c46677e605ba3c268f",
      playerId: 1082,
      playerName: "Kartick Banerjee ",
      playerNickName: "Tai",
      dob: "2002-04-24T00:00:00.000Z",
      weight: "55 kg",
      height: "5 ft 7 inch",
      tShirtSize: "m",
      mobile: "8944995651",
      aadharId: "282666445067",
      address: "Junbedia",
      district: "Bankura ",
      state: "WB",
      pinCode: "722155",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/0eaf62a6-6344-479f-8e92-1aa39f7df12a-1000068790.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/ed060e12-8637-435a-a1aa-72a9d1f4f666-Screenshot_20250126_211924.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679659c46677e605ba3c2690",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679671c1a4ca600e5422ff75",
      playerId: 1083,
      playerName: "Arup Mukherjee",
      playerNickName: "Arup",
      dob: "1997-04-22T00:00:00.000Z",
      weight: "60",
      height: '5"5',
      tShirtSize: "m",
      mobile: "7319049615",
      aadharId: "353257082497",
      address: "jambad",
      district: "Purulia ",
      state: "WB",
      pinCode: "723128",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/19d118c3-f87b-4b2d-a560-2cb2d76fca5f-inbound7291430763409784612.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b0793f15-dac8-48ae-9ae5-fac9a147971e-inbound3004097985933238511.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679671c1a4ca600e5422ff76",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797242a0fe3b4b8b64a6e63",
      playerId: 1084,
      playerName: "SHUVAM BANERJEE ",
      playerNickName: "Naga",
      dob: "1994-12-25T00:00:00.000Z",
      weight: "75",
      height: "5ft 9inch",
      tShirtSize: "l",
      mobile: "8172032272",
      aadharId: "253548086073",
      address: "Khatra subhaspally ",
      district: "Bankura",
      state: "WB",
      pinCode: "722140",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e9c5fd2e-176a-4f68-b251-0f00c206310f-inbound6198521345494888110.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1a595d07-6f22-491f-a9d1-ae19be941e29-inbound9122433406808880402.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797242a0fe3b4b8b64a6e64",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797251f0fe3b4b8b64a6fc1",
      playerId: 1085,
      playerName: "Dibyendu Khan",
      playerNickName: "Dolon",
      dob: "1995-01-18T00:00:00.000Z",
      weight: "74",
      height: "5'8",
      tShirtSize: "xl",
      mobile: "07602057690",
      aadharId: "442555433116",
      address: "Jhantipahari",
      district: "Bankura ",
      state: "WB",
      pinCode: "722137",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b40f3087-51c0-4fc3-9fc7-469b0b56dd8c-1000049605.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/c514f374-20e2-427a-a883-52d28d8c9743-Screenshot_20250127_114700.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797251f0fe3b4b8b64a6fc2",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679726480fe3b4b8b64a6fc7",
      playerId: 1086,
      playerName: "SOMNATH KARMAKAR",
      playerNickName: "SOMU",
      dob: "1993-10-11T00:00:00.000Z",
      weight: "62",
      height: "5'-9\"",
      tShirtSize: "xl",
      mobile: "7872194592",
      aadharId: "933964153275",
      address: "GOURANGADIH",
      district: "PURULIA",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/0608380c-5c16-4104-9bf9-ce19251a5eb6-GPP.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/321f5ea3-a0ab-411c-89aa-eace79097c6f-GPP-1.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679726480fe3b4b8b64a6fc8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67972ca56f5dd05d815f3a7f",
      playerId: 1087,
      playerName: "Bijay Gorain",
      playerNickName: "Bijay",
      dob: "1996-12-03T00:00:00.000Z",
      weight: "85",
      height: '5"9',
      tShirtSize: "xl",
      mobile: "9547762340",
      aadharId: "433344814969",
      address: "Ropo",
      district: "Purulia ",
      state: "WB",
      pinCode: "723213",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "offSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7575860f-012c-4425-8036-674f118d2673-inbound3026669727152987595.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5d2f41b9-7a13-4e81-9835-3c7953f07bbe-inbound4716990736496936633.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67972ca56f5dd05d815f3a80",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67973c1c1cab2092fd1b7a62",
      playerId: 1088,
      playerName: "ARUP SINGHA",
      playerNickName: "HURUM",
      dob: "1989-02-21T00:00:00.000Z",
      weight: "72",
      height: "5'-11\"",
      tShirtSize: "xl",
      mobile: "9007276314",
      aadharId: "954055033019",
      address: "SAHARJORA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b774d705-01c9-4b74-ac19-5fe9f565bb68-hu.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/16a1a17b-c907-401f-b237-7eb24c8e79db-PA.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67973c1c1cab2092fd1b7a63",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679744a083e23e1df6567147",
      playerId: 1089,
      playerName: "Sk Nabab(Nabab) ",
      playerNickName: "Nabab",
      dob: "1990-04-23T00:00:00.000Z",
      weight: "65",
      height: "5'10",
      tShirtSize: "l",
      mobile: "8240962017",
      aadharId: "368177891678",
      address: "Machantalla",
      district: "Bankura",
      state: "WB",
      pinCode: "722101",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e6d1d068-f4b2-4dbd-8811-0134c63e8d77-IMG-20241117-WA0005%281%29_1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/eafa9837-c813-43d7-8e64-d5aab095718c-Screenshot_20250127-134444.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679744a083e23e1df6567148",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679746e883e23e1df6567206",
      playerId: 1090,
      playerName: "Santanu panda",
      playerNickName: "Santu panda",
      dob: "1990-04-28T00:00:00.000Z",
      weight: "90kg",
      height: "6.1",
      tShirtSize: "xxl",
      mobile: "7047840587",
      aadharId: "617092010413",
      address: "Saldiha",
      district: "Bankura ",
      state: "WB",
      pinCode: "722173",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/04d0fa76-c5e6-4f53-9a3e-c86eceffeb0a-1000058974.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/36499615-c477-4fa7-a897-27e26f7029f9-Screenshot_20250127_140154.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679746e883e23e1df6567207",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797499383e23e1df6567320",
      playerId: 1091,
      playerName: "SOURAV CHATTERJEE",
      playerNickName: "Sourav ",
      dob: "1997-02-02T00:00:00.000Z",
      weight: "85",
      height: "6 ft",
      tShirtSize: "xl",
      mobile: "7872832019",
      aadharId: "840965680227",
      address: "Tiluri",
      district: "Bankura",
      state: "WB",
      pinCode: "722153",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/bd38d725-77a2-4b88-b4e6-9b16ae59ca8a-inbound118551870770404043.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/fa4e1634-7856-471a-854b-e747dd6082ab-inbound891718812550311647.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797499383e23e1df6567321",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67974bf483e23e1df6567326",
      playerId: 1092,
      playerName: "Bijoy Sahani",
      playerNickName: "Bijoy",
      dob: "1985-10-23T00:00:00.000Z",
      weight: "80",
      height: "5'8\"",
      tShirtSize: "xxl",
      mobile: "7001525806",
      aadharId: "500917803020",
      address: "Surya sen pally",
      district: "Purulia",
      state: "WB",
      pinCode: "723101",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2fb773bb-8a17-411f-a441-731e9779a9e9-inbound7340861311262002370.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/390aeb82-6621-4699-810f-d9a3ad42b289-inbound3264227233864733449.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67974bf483e23e1df6567327",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67975856fae7c6f687f31d8b",
      playerId: 1093,
      playerName: "MD RAHAT MOLLICK",
      playerNickName: "RAHAT",
      dob: "2004-03-15T00:00:00.000Z",
      weight: "70",
      height: "5.8",
      tShirtSize: "xl",
      mobile: "+916295181137",
      aadharId: "272466722741",
      address: "Badulara",
      district: "Bankura ",
      state: "WB",
      pinCode: "722102",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b557b1e2-228e-4561-8d04-42ed2d55bd62-inbound6470120559581931051.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/af68b375-0be8-4c52-8731-4c36660073b9-inbound1135182825665643185.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67975856fae7c6f687f31d8c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797903c92745827b2848b2a",
      playerId: 1094,
      playerName: "Baidurya kanti dube ",
      playerNickName: "Bodhi",
      dob: "2003-11-10T00:00:00.000Z",
      weight: "100",
      height: "6.2",
      tShirtSize: "5xl",
      mobile: "7908901293",
      aadharId: "988276999959",
      address: "Gangajal ghati ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722133",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/395e6425-2d42-4cd4-aef8-140980cdbf3c-1000180746.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0090711c-c28a-42a7-943b-5635bdaa69c4-Screenshot_2025-01-27-19-20-28-49_4336b74596784d9a2aa81f87c2016f50.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797903c92745827b2848b2b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797aabf9277b6d3dff98281",
      playerId: 1096,
      playerName: "Sk sohial ",
      playerNickName: "Sk sohial ",
      dob: "2001-11-23T00:00:00.000Z",
      weight: "60",
      height: "5.5",
      tShirtSize: "l",
      mobile: "7031689777",
      aadharId: "805912422725",
      address: "Schooldanga ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5bdd432e-05d8-42c4-b4c0-b8b0fea72625-IMG_20240816_232702_183.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8559db21-1c0c-4c79-9a0a-3cd66c366d4c-IMG-20250127-WA0003.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797aabf9277b6d3dff98282",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797b54148bf9c14375e9b57",
      playerId: 1097,
      playerName: "SK RAJEN HOSSAIN ",
      playerNickName: "RAJEN",
      dob: "1991-10-28T00:00:00.000Z",
      weight: "57",
      height: "5.8",
      tShirtSize: "l",
      mobile: "6297536007",
      aadharId: "8738 3452 3913",
      address: "IDGAMAHALLA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722101",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/78b1efeb-2b53-4e9d-bb7f-940cb9bbc573-1000063127.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/520a2dd0-42f0-4662-b333-b3a8ecba3e66-Screenshot_2025-01-27-21-57-22-15_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797b54148bf9c14375e9b58",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6797d4020ca3bd72c6ecccd8",
      playerId: 1098,
      playerName: "NAYAN TUDU ",
      playerNickName: "GAYLE ",
      dob: "1997-02-04T00:00:00.000Z",
      weight: "72",
      height: "5'8",
      tShirtSize: "l",
      mobile: "9002421639",
      aadharId: "330551185134",
      address: "CHHATNA ",
      district: "BANKURA ",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3ded1afd-a01e-4949-befc-2f6bfcc8cbbe-Picsart_22-10-24_01-37-56-201.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8a8e7af8-312e-4b7c-af2e-78821229e826-IMG-20250128-WA0000.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6797d4020ca3bd72c6ecccd9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679848b77aa2c7270070ca3d",
      playerId: 1099,
      playerName: "Mukesh Singha",
      playerNickName: "Mukesh",
      dob: "1988-06-17T00:00:00.000Z",
      weight: "80",
      height: "5.6ft",
      tShirtSize: "l",
      mobile: "7908995155",
      aadharId: "869764777291",
      address: "Barjora",
      district: "Bankura",
      state: "WB",
      pinCode: "722202",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/490b164c-ec49-4e82-9b98-14e1433eba72-inbound3724962055092599659.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1a583196-29aa-4fa8-a24b-c39060b8ada6-inbound7186190511090304140.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679848b77aa2c7270070ca3e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679849027aa2c7270070ca43",
      playerId: 1100,
      playerName: "Shiba Prasad Daripa ",
      playerNickName: "Balaram",
      dob: "2000-07-01T00:00:00.000Z",
      weight: "95kg",
      height: "6.3",
      tShirtSize: "xxl",
      mobile: "8637558359",
      aadharId: "668184121610",
      address: "Manbazar",
      district: "Purulia",
      state: "WB",
      pinCode: "723128",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/03216994-1762-47d1-94d5-8f36e0568c22-Screenshot_2024-09-23-14-12-40-38_92460851df6f172a4592fca41cc2d2e6.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f6413047-90a7-40f7-9484-b7ce8e4f9104-Screenshot_2025-01-28-08-26-33-98_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679849027aa2c7270070ca44",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679849d27aa2c7270070ca49",
      playerId: 1101,
      playerName: "Subhadip Chatterjee ",
      playerNickName: "Subha",
      dob: "1995-10-23T00:00:00.000Z",
      weight: "75",
      height: "5.8",
      tShirtSize: "xl",
      mobile: "7679315364",
      aadharId: "963794364113",
      address: "Bongabari",
      district: "Purulia ",
      state: "WB",
      pinCode: "723147",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8d619239-1a2e-4c76-96c0-547b520ffba9-1000034441.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/18feff48-ceed-450f-ae28-fdbc2ea486a6-IMG-20250128-WA0003.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679849d27aa2c7270070ca4a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679861ade6cae68d2723a7a7",
      playerId: 1102,
      playerName: "GIRIDHARI MONDAL",
      playerNickName: "GIRI",
      dob: "1998-03-02T00:00:00.000Z",
      weight: "60",
      height: "5'-6\"",
      tShirtSize: "m",
      mobile: "8207065929",
      aadharId: "893208382469",
      address: "SUSUNIA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1e5bbe60-c613-4b54-8fed-b267e5398637-G-1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b3243066-d6c9-4954-ad60-9b9c051aa8c7-G-2.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679861ade6cae68d2723a7a8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67986313e6cae68d2723a87a",
      playerId: 1103,
      playerName: "Aveesek Rakshit",
      dob: "1988-10-01T00:00:00.000Z",
      weight: "80",
      height: "5'-11",
      tShirtSize: "xl",
      mobile: "8918687746",
      aadharId: "581841348186 ",
      address: "AMARKANAN",
      district: "BANKURA",
      state: "WB",
      pinCode: "722133",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2981321a-a643-4c98-9393-26c23dedc3a0-ARK-40.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5b72f189-7bf6-4871-9e51-526aebd58122-ARK-41.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67986313e6cae68d2723a87b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67986777c89ac8ad79962dcf",
      playerId: 1104,
      playerName: "Bikash kr. Sharma ",
      playerNickName: "Chotiya",
      dob: "1990-11-24T00:00:00.000Z",
      weight: "73",
      height: "5'8",
      tShirtSize: "l",
      mobile: "7001542013",
      aadharId: "663293883101",
      address: "Balrampur",
      district: "Purulia",
      state: "WB",
      pinCode: "723143",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3ce3c630-4fdb-43c5-a98b-dc029f142aa9-IMG-20241205-WA0003.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/022d173b-8c46-4fcf-a852-daa8c90e1aff-IMG-20250128-WA0001.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67986777c89ac8ad79962dd0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67987fa7295fd22f0957387c",
      playerId: 1106,
      playerName: "Prakash halwai ",
      playerNickName: "Pkku",
      dob: "1999-03-22T00:00:00.000Z",
      weight: "75",
      height: "6ft",
      tShirtSize: "l",
      mobile: "9614466950",
      aadharId: "995372421466",
      address: "Balarampur ",
      district: "Purulia ",
      state: "WB",
      pinCode: "723143",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/020bb2bc-5948-4c5a-b02b-23fb8655bdb5-IMG_20241230_174604.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5f182f4e-e8c0-486b-ad7c-1ff83f412429-Screenshot_2025-01-28-12-26-12-67_4336b74596784d9a2aa81f87c2016f50.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67987fa7295fd22f0957387d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6798803d295fd22f09573954",
      playerId: 1107,
      playerName: "Dhanajay bauri ",
      playerNickName: "Jagat",
      dob: "1995-03-10T00:00:00.000Z",
      weight: "60",
      height: "5.7",
      tShirtSize: "xl",
      mobile: "8945079708",
      aadharId: "586970197424",
      address: "Gosalamore",
      district: "Purulia",
      state: "WB",
      pinCode: "723148",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/51df30b0-4450-40e5-b2a1-c795416ecc45-IMG_20240412_013139_176.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9fe34c23-5ecd-4965-8bb9-b0debf4734e9-IMG-20250128-WA0004.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6798803d295fd22f09573955",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6798810c295fd22f09573a2e",
      playerId: 1108,
      playerName: "Amar Das",
      playerNickName: "ROCKY ",
      dob: "2001-04-17T00:00:00.000Z",
      weight: "63",
      height: "5'8",
      tShirtSize: "l",
      mobile: "7583971777",
      aadharId: "908026482263",
      address: "Banpukuria ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722121",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/70b5371d-6c44-4483-8999-5fbdd51472a0-1000386178.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3a8d275a-04c1-4ddb-ae21-c02a4b88696a-Screenshot_2025-01-28-12-24-00-568_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6798810c295fd22f09573a2f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679886a5295fd22f09573b0d",
      playerId: 1109,
      playerName: "Subir Karmakar ",
      playerNickName: "Pola",
      dob: "1999-12-24T00:00:00.000Z",
      weight: "60kg ",
      height: "5.6",
      tShirtSize: "m",
      mobile: "7061568038",
      aadharId: "369058880391",
      address: "Gopalnagar-Manbazar",
      district: "Purulia",
      state: "WB",
      pinCode: "723128",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ff3f4939-413f-4472-bc42-b3d3f05dce00-IMG-20250128-WA0006.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5c33c794-1def-43b8-b1e5-a6519f3ec991-IMG-20250128-WA0009.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679886a5295fd22f09573b0e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6798a251bbc8a7c977f4f342",
      playerId: 1110,
      playerName: "Jim banerjee",
      playerNickName: "Jim",
      dob: "1988-12-22T00:00:00.000Z",
      weight: "74",
      height: "5 ft 7",
      tShirtSize: "l",
      mobile: "8250920914",
      aadharId: "423737761613",
      address: "Maliara",
      district: "Bankura",
      state: "WB",
      pinCode: "722142",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/88f38ba9-ddd7-495a-98c8-53f8a5d0876c-1000549701.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/fdae1dee-8ccc-40b2-8834-affdf03283e5-Screenshot_20250128_144854.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6798a251bbc8a7c977f4f343",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6798a3efbbc8a7c977f4f348",
      playerId: 1111,
      playerName: "Ramesh ghosh",
      playerNickName: "Ramesh",
      dob: "1992-03-29T00:00:00.000Z",
      weight: "75",
      height: "5 ft 10",
      tShirtSize: "l",
      mobile: "6290348627",
      aadharId: "661958560567",
      address: "Ghutgoria",
      district: "Bankura",
      state: "WB",
      pinCode: "722168",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/80ed632a-c93e-4eec-8a53-44530ffe1130-1000549711.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/307f9ecb-9978-47be-953c-aa5e54c950c1-Screenshot_20250128_145600.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6798a3efbbc8a7c977f4f349",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6798e5e329a79759bf69911b",
      playerId: 1112,
      playerName: "Ron Chakraborty",
      playerNickName: "Ron",
      dob: "1997-08-12T00:00:00.000Z",
      weight: "62",
      height: "5.8 ",
      tShirtSize: "m",
      mobile: "09749523884",
      aadharId: "604363947166",
      address: "Krishnapur bazar",
      district: "Purulia",
      state: "WB",
      pinCode: "723156",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e1a9de55-1d1e-4f52-97f5-8ca6d4ff8a10-IMG_20250127_221852_685.webp",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6229c48a-c2da-4610-ae65-5be9071266cc-Screenshot_2025-01-28-19-40-52-20_4336b74596784d9a2aa81f87c2016f50.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6798e5e329a79759bf69911c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6798f930aa02cd8875307f47",
      playerId: 1113,
      playerName: "Rana Adhikary ",
      playerNickName: "Rana",
      dob: "1995-01-03T00:00:00.000Z",
      weight: "62",
      height: "5.5'",
      tShirtSize: "m",
      mobile: "8170909395",
      aadharId: "882207339718",
      address: "Raghabpur",
      district: "Purulia",
      state: "WB",
      pinCode: "723101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/20d0ccf0-23d9-4ff7-bd6c-ec5beaac30ef-1000131133-removebg-preview.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/7f89844d-52ee-4278-9f94-db58d109bca5-IMG-20250128-WA0006.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6798f930aa02cd8875307f48",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67990c254be52e3a30a04ed7",
      playerId: 1114,
      playerName: "Younis khan ",
      playerNickName: "Gaba",
      dob: "1989-07-22T00:00:00.000Z",
      weight: "60",
      height: "5.5 fit ",
      tShirtSize: "m",
      mobile: "9064641145",
      aadharId: "928471031530",
      address: "Bishnupur ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722122",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/aaf6c687-251b-45a1-adcd-83c106f6c105-inbound6331192935666507369.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9d6a934d-829b-4bf7-b000-40d73bdb6af9-inbound3707208642140299136.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67990c254be52e3a30a04ed8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67990f684be52e3a30a04edd",
      playerId: 1115,
      playerName: "Satyasadhan Rajak ",
      playerNickName: "Indra",
      dob: "1994-03-12T00:00:00.000Z",
      weight: "64",
      height: "5,10",
      tShirtSize: "m",
      mobile: "9800147422",
      aadharId: "4369 9678 5574",
      address: "Simul bera",
      district: "Purulia ",
      state: "WB",
      pinCode: "723103",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a422c212-221f-4778-91f6-359f18f10a28-1000114018.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/901e3c82-3eb7-433e-9c5c-f9e8210654e5-Screenshot_20250128-223901_PhonePe.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67990f684be52e3a30a04ede",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67992121abbce80151eb6d39",
      playerId: 1116,
      playerName: "ANIMESH ROY",
      playerNickName: "Animesh",
      dob: "1996-10-09T00:00:00.000Z",
      weight: "76",
      height: "5.11",
      tShirtSize: "xl",
      mobile: "8670536971",
      aadharId: "494487497139",
      address: "Nirisha",
      district: "Bankura",
      state: "WB",
      pinCode: "722203",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8071924e-d26b-488e-b651-1513f29ab15e-1000136224.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/21f9c092-5acf-457f-a31f-c7da0a4db0ad-Screenshot_2025-01-28-23-45-23-902_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67992121abbce80151eb6d3a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799874e43e42aa403c347c4",
      playerId: 1117,
      playerName: "Bijoy Roy",
      playerNickName: "Bijoy Roy",
      dob: "1997-10-11T00:00:00.000Z",
      weight: "75(kg)",
      height: "6(ft)",
      tShirtSize: "xl",
      mobile: "9800148575",
      aadharId: "564271387015",
      address: "Bagda-Puncha",
      district: "Purulia ",
      state: "WB",
      pinCode: "723151",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/fbb727c1-d051-41b4-84eb-308c3d8fe654-1000487986.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/36822e3b-4fe4-4e76-8421-4e6c723a0db6-Screenshot_2025-01-29-07-07-39-936_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799874e43e42aa403c347c5",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799a5c7023dc2376e99f6d0",
      playerId: 1118,
      playerName: "Sujay Banerjee ",
      playerNickName: "Sujay",
      dob: "1991-12-27T00:00:00.000Z",
      weight: "60kg",
      height: "5 feet 5 inch",
      tShirtSize: "m",
      mobile: "8768470187",
      aadharId: "503416833495",
      address: "Mancha-Patrasayer",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/500a30b5-19b6-434a-a91c-a147a9a4cf3f-1000217542.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6a85ff6b-6d11-4d8e-8f94-86d7eb938579-Screenshot_20250129-090525.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799a5c7023dc2376e99f6d1",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799aed33cd1981c700f60c3",
      playerId: 1119,
      playerName: "Surajit patra ",
      playerNickName: "Sura",
      dob: "1999-10-08T00:00:00.000Z",
      weight: "60",
      height: "180",
      tShirtSize: "l",
      mobile: "9647402004",
      aadharId: "785730709685",
      address: "Binodpur",
      district: "Bankura ",
      state: "WB",
      pinCode: "722121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e1a3febf-7183-47b5-80c3-d23cf811c9bd-1000027171.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b6de1bea-b37a-443f-ba89-9528d43f3f3e-Screenshot_20250129_095831_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799aed33cd1981c700f60c4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799b79b3cd1981c700f62b6",
      playerId: 1120,
      playerName: "Bhaskar Bauri ",
      playerNickName: "Bhaskar ",
      dob: "2000-10-05T00:00:00.000Z",
      weight: "75",
      height: "167",
      tShirtSize: "xl",
      mobile: "8918573745",
      aadharId: "484097932796",
      address: "Thakursima(BORAM)",
      district: "purulia ",
      state: "WB",
      pinCode: "723201",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5489e898-e94d-4e11-8ced-720788110097-inbound7635243123906606151.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cf746bea-335d-420c-8a82-f4fcbff0e834-inbound9044562628478894805.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799b79b3cd1981c700f62b7",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799bb263cd1981c700f63ad",
      playerId: 1121,
      playerName: "Kamal shaw",
      playerNickName: "Kamal",
      dob: "1996-03-17T00:00:00.000Z",
      weight: "83",
      height: "5ft10cm",
      tShirtSize: "l",
      mobile: "8250286985",
      aadharId: "742880707371",
      address: "kamlasthan-Adra ",
      district: "Purulia",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1f8db52c-12cf-4fc0-9472-d52ae9730597-inbound2030393489162731167.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/850337b2-b3a0-4f10-82ff-da3732d5e536-inbound6741495705189466965.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799bb263cd1981c700f63ae",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799bc4d3cd1981c700f651e",
      playerId: 1122,
      playerName: "Arup Rana",
      dob: "1999-08-01T00:00:00.000Z",
      weight: "56",
      height: "5.5",
      tShirtSize: "m",
      mobile: "6295333512",
      aadharId: "991523132797",
      address: "Kanchanpur",
      district: "Bankura ",
      state: "WB",
      pinCode: "722155",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7365340f-b7ca-4eba-a5ad-b0ae46f8bd33-inbound4922052155703971473.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/32f4391a-0461-4a66-b653-34a38ca7f98b-inbound1264431215759954660.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799bc4d3cd1981c700f651f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799d1ba8bf3144936681794",
      playerId: 1123,
      playerName: "Dipankar Pattanayak",
      playerNickName: "DIP",
      dob: "1989-01-03T00:00:00.000Z",
      weight: "72",
      height: "5'-5\"",
      tShirtSize: "xl",
      mobile: "9832991492",
      aadharId: "294747940460",
      address: "GOGRA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722137",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9eb4320c-db29-4909-93f0-a5d480d8faba-deep%20patta-1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/33104261-e470-45bc-bcd0-1381d1127b16-G-2.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799d1ba8bf3144936681795",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799db848bf3144936681e5c",
      playerId: 1125,
      playerName: "Riju Rakshit ",
      playerNickName: "Riju",
      dob: "1998-08-09T00:00:00.000Z",
      weight: "80 kg",
      height: "5.7 ft",
      tShirtSize: "l",
      mobile: "7585886884",
      aadharId: "818148391884",
      address: "Bhalaidiha",
      district: "Bankura ",
      state: "WB",
      pinCode: "722139",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f461e1be-41cd-4888-a2d6-b2cd5ef54e81-1000157510.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/083cc10e-16cb-4346-a024-b0c33fd6bb00-Screenshot_20250129_130738.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799db848bf3144936681e5d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799dbd08bf3144936681f5a",
      playerId: 1126,
      playerName: "MARSHAL HEMBRAM",
      dob: "1991-11-12T00:00:00.000Z",
      weight: "95",
      height: "6",
      tShirtSize: "xxl",
      mobile: "9474117640",
      aadharId: "656688638381",
      address: "Fulkushma",
      district: "Bankura",
      state: "WB",
      pinCode: "722162",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a08bd2ab-2345-4588-b160-fb12b2d49651-1000333512.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/548b072f-0cd6-4a62-b015-5daed2fc7bc2-Screenshot_2025-01-29-13-11-47-93_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799dbd08bf3144936681f5b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799defa8bf31449366820dd",
      playerId: 1127,
      playerName: "Tamajit Ghosal ",
      playerNickName: "Apple ",
      dob: "2000-05-08T00:00:00.000Z",
      weight: "62",
      height: "5' 5\"",
      tShirtSize: "m",
      mobile: "6296352451",
      aadharId: "989645034089",
      address: "kadmaghati ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722155",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e261c684-b213-4c8b-8208-251ad2da79c0-Screenshot_2024-12-05-11-33-54-924_com.google.android.apps.docs.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a51cbab6-7805-420d-bf34-e8d488ece353-Screenshot_2025-01-29-13-21-38-060_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799defa8bf31449366820de",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "6799f13075257f37e7bda121",
      playerId: 1128,
      playerName: "RONIK CHATTERJEE ",
      playerNickName: "RONIK",
      dob: "2005-09-11T00:00:00.000Z",
      weight: "75",
      height: "6fyt ",
      tShirtSize: "xl",
      mobile: "7679348614",
      aadharId: "861347466793",
      address: "LADHURKA (HURA)",
      district: "PURULIA ",
      state: "WB",
      pinCode: "723148",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d36419a1-3456-4be4-9edc-9ea445dad547-1000001174.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b8e9ec85-8b8f-48af-abb7-6b26a76e3659-IMG20240213091054.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "6799f13075257f37e7bda122",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a01c2c71894679096a1cf",
      playerId: 1129,
      playerName: "BIKRAMJIT MANDAL",
      playerNickName: "BIKRAM",
      dob: "1998-11-28T00:00:00.000Z",
      weight: "68",
      height: "5,7",
      tShirtSize: "l",
      mobile: "8343808446",
      aadharId: "459626754336",
      address: "Sunukpahari ",
      district: "Bankura",
      state: "WB",
      pinCode: "722136",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/60203e5c-eac3-45f7-aead-d60fb9a268c3-1000187883.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/953a0c62-c110-4c94-ac35-d447cd5f8486-Screenshot_20250129_155240.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a01c2c71894679096a1d0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a1b66ae31a724185dbf89",
      playerId: 1130,
      playerName: "Nikhil Samanta",
      playerNickName: "Nikhil",
      dob: "1989-04-25T00:00:00.000Z",
      weight: "72",
      height: "5'-5\"",
      tShirtSize: "xl",
      mobile: "8617585925",
      aadharId: "901072313773",
      address: "BANKURA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722102",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e4fb6c61-d6a7-4d8d-bbfe-5de6e8a5e070-N1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/07148586-5717-4b90-81ac-42fe04a5d255-75454749-b9c6-42f7-8150-f880a8c789af.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a1b66ae31a724185dbf8a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a1b81ae31a724185dc094",
      playerId: 1131,
      playerName: "BISHAL SAW ",
      playerNickName: "Bittu",
      dob: "2000-12-16T00:00:00.000Z",
      weight: "60",
      height: "175",
      tShirtSize: "m",
      mobile: "7384595454",
      aadharId: "536749763901",
      address: "Jhalda",
      district: "Purulia",
      state: "WB",
      pinCode: "723212",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d3152fc6-0d90-45eb-bdd9-eb27f909c027-inbound4040523970230123528.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8a037a26-d6bb-4853-aa6c-37ccd6c59b42-inbound3476897214817936369.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a1b81ae31a724185dc095",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a1f1aae31a724185dc226",
      playerId: 1132,
      playerName: "RAJU SINGHA ",
      playerNickName: "RAJU",
      dob: "1995-04-09T00:00:00.000Z",
      weight: "75kg",
      height: "5'5",
      tShirtSize: "m",
      mobile: "8637565105",
      aadharId: "557252117104",
      address: "LAKHMANPUR",
      district: "BANKURA ",
      state: "WB",
      pinCode: "722133",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f60f7f6a-07c0-45a8-8500-2d90b7185e5d-inbound4388342889994251521.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9b2a89b1-46ec-4fca-88e9-d8a79ebe32c9-inbound8340541776721111581.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a1f1aae31a724185dc227",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a2071ae31a724185dc22c",
      playerId: 1133,
      playerName: "Akshay Das",
      dob: "1988-04-20T00:00:00.000Z",
      weight: "68",
      height: "5.11",
      tShirtSize: "xl",
      mobile: "6295408924",
      aadharId: "853432661508",
      address: "Indas",
      district: "Bankura",
      state: "WB",
      pinCode: "722205",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d5b670f9-6dc3-48f5-89d0-ab6f210a272c-1000004050.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cadbfc3a-097c-4261-af8c-4f18cb9921da-Screenshot_20250129-180230.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a2071ae31a724185dc22d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a31f68d8cc72cf537dcdf",
      playerId: 1134,
      playerName: "Tushar Kanti Mahato ",
      playerNickName: "Tushar",
      dob: "2001-07-01T00:00:00.000Z",
      weight: "56",
      height: "5 ft 1",
      tShirtSize: "m",
      mobile: "9163220425",
      aadharId: "688969566644",
      address: "Gopalpur",
      district: "Purulia ",
      state: "WB",
      pinCode: "723102",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/65a645f1-edc6-4910-b97f-815f366fbb4b-InShot_20250129_191558048.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1ba2289a-6ec9-4d74-a976-30902eee9330-Screenshot_20250129-191042.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a31f68d8cc72cf537dce0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a352b8d8cc72cf537ddf2",
      playerId: 1135,
      playerName: "Abhijit Roy ",
      playerNickName: "Naru",
      dob: "1993-05-01T00:00:00.000Z",
      weight: "63",
      height: "5'2\"",
      tShirtSize: "m",
      mobile: "7001353008",
      aadharId: "957720627429",
      address: "BISHNUPUR ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722122",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a4c70aef-8117-48f6-a607-6f31b22b1f8d-IMG_20230726_171301.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b009f9ee-0f38-4436-8227-b7252d6cd794-Screenshot_20250129_192748.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a352b8d8cc72cf537ddf3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a38018d8cc72cf537df8d",
      playerId: 1136,
      playerName: "Jhulan Roy",
      playerNickName: "Jhulan",
      dob: "1991-10-02T00:00:00.000Z",
      weight: "68",
      height: "5.9",
      tShirtSize: "l",
      mobile: "7001183001",
      aadharId: "901381613667",
      address: "Begunkodar",
      district: "Purulia",
      state: "WB",
      pinCode: "723202",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/13f831b9-00f6-4ee3-8f42-c340e21a5fa9-inbound7229555136904497950.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3df4dd33-db5b-49aa-b7c6-e4262ef99632-inbound5570360941896065817.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a38018d8cc72cf537df8e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a3c2d8d8cc72cf537e3d5",
      playerId: 1137,
      playerName: "PRADIP SIKDAR ",
      playerNickName: "MASTER ",
      dob: "1987-01-02T00:00:00.000Z",
      weight: "75kg",
      height: "5.7(ft)",
      tShirtSize: "xl",
      mobile: "8972360455",
      aadharId: "972517744006",
      address: "sonamukhi",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4331ba27-0008-4822-b851-504fe62f3fab-1000074841.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/675c1937-60bd-4033-ba0e-26236195b2c7-Screenshot_20250129-195508.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a3c2d8d8cc72cf537e3d6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a3e9d8d8cc72cf537e5fe",
      playerId: 1138,
      playerName: "Joy biswas ",
      playerNickName: "Bumba",
      dob: "1989-03-03T00:00:00.000Z",
      weight: "85",
      height: "5\"8'",
      tShirtSize: "xxl",
      mobile: "7501482153",
      aadharId: "920621961163",
      address: "Sonamukhi ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ced9b467-bd49-4af8-a59e-448fa5cfe66b-IMG-20250129-WA0048.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/26147082-28a5-40ac-8045-9240725edebb-IMG-20250129-WA0050.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a3e9d8d8cc72cf537e5ff",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a4b1bf6077944d50a8f91",
      playerId: 1139,
      playerName: "BIKASH MAHATO",
      playerNickName: "BIKASH",
      dob: "1997-10-08T00:00:00.000Z",
      weight: "65 KG",
      height: "165 CM",
      tShirtSize: "m",
      mobile: "9064730956",
      aadharId: "7171 2231 4095",
      address: "CHAKRA",
      district: "PURULIA",
      state: "WB",
      pinCode: "723149",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/269beb67-7a49-4834-b40f-cd42f9e87071-1000321182.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e0c59a44-2743-4ea5-986a-1dff5b8aacd1-Screenshot_2025-01-29-21-03-03-35_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a4b1bf6077944d50a8f92",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a4bcef6077944d50a8f97",
      playerId: 1140,
      playerName: "sudarshan ghosh",
      playerNickName: "Vanu",
      dob: "1993-02-25T00:00:00.000Z",
      weight: "70",
      height: "722138",
      tShirtSize: "l",
      mobile: "9564686425",
      aadharId: "753099616438",
      address: "Hirapur-joypur",
      district: "BANKURA",
      state: "WB",
      pinCode: "722138",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/02c4a3c2-918a-4f5e-9030-f3f863ca3cda-inbound481892409983902270.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/fd44a82c-3baa-430d-a00c-f7c0e2cb5029-inbound4321663232100774152.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a4bcef6077944d50a8f98",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679a5cfbb66bdca576cb2717",
      playerId: 1141,
      playerName: "Rohan Mukherjee",
      playerNickName: "Jonty",
      dob: "1989-01-14T00:00:00.000Z",
      weight: "67 kg",
      height: "5 feet 7.5 inches ",
      tShirtSize: "l",
      mobile: "8910323370",
      aadharId: "896584468844688864",
      address: "Surpanager",
      district: "Bankura",
      state: "WB",
      pinCode: "722144",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f14d6df8-44a1-4039-87f6-3ee6da75e8a2-IMG_3477.jpeg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/dea27cea-5e8f-4b9a-9a6e-07407ef1ad2e-IMG_3487.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679a5cfbb66bdca576cb2718",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b0f5ba1fb041b37e2375b",
      playerId: 1142,
      playerName: "Bapi rajak",
      playerNickName: "Bapi",
      dob: "2002-09-17T00:00:00.000Z",
      weight: "58",
      height: '5"5',
      tShirtSize: "l",
      mobile: "+916379658756",
      aadharId: "842668709801",
      address: "Simulbera",
      district: "Purulia ",
      state: "WB",
      pinCode: "723103",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/82053b80-d19d-45fd-bc4c-46a3cafdb220-inbound733800677212872073.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d06706be-9cd4-43b2-98c5-57d72edab4af-inbound3960377492476986115.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b0f5ba1fb041b37e2375c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b15baa1fb041b37e2398c",
      playerId: 1143,
      playerName: "SUBHENDU SEKHAR MANTA",
      playerNickName: "GOPAL",
      dob: "1990-05-01T00:00:00.000Z",
      weight: "67",
      height: "5'-5\"",
      tShirtSize: "m",
      mobile: "8637031561",
      aadharId: "969134539467",
      address: "MTPS",
      district: "BANKURA",
      state: "WB",
      pinCode: "722183",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c2b48bce-1379-4edb-abbd-553cce37dd0c-GOPAL.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4c896455-bc01-4279-b7d4-ddb8fd6a3cce-busa%20logo.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b15baa1fb041b37e2398d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b199f234e0da6440b9c40",
      playerId: 1144,
      playerName: "PRAVIN SINGH",
      playerNickName: "PRAVIN",
      dob: "1984-04-06T00:00:00.000Z",
      weight: "75",
      height: "5'-10\"",
      tShirtSize: "xl",
      mobile: "9832270100",
      aadharId: "816232456154",
      address: "Rathtala",
      district: "PURULIA",
      state: "WB",
      pinCode: "723101",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ebda9957-5301-4beb-a61f-0ba3a9b41155-PARV.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9ba75b8e-a76d-44f3-9208-a07540fc20ef-hhhh.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b199f234e0da6440b9c41",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b1c44234e0da6440b9d61",
      playerId: 1145,
      playerName: "APURBA GHOSH",
      playerNickName: "APU",
      dob: "1998-11-10T00:00:00.000Z",
      weight: "64",
      height: "5'-6\"",
      tShirtSize: "m",
      mobile: "9064610920",
      aadharId: "525622952212",
      address: "AMARKANAN",
      district: "BANKURA",
      state: "WB",
      pinCode: "722133",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "offSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f3f510a1-5c4e-437c-af67-7555e2c285f4-APUIM.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/acdcc6d3-40af-4b30-948c-d576d042f7e1-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b1c44234e0da6440b9d62",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b21c4234e0da6440ba02b",
      playerId: 1146,
      playerName: "RAHUL SINGHA THAKUR",
      playerNickName: "MONO",
      dob: "1995-10-14T00:00:00.000Z",
      weight: "78",
      height: "5'8\"",
      tShirtSize: "xxl",
      mobile: "6294216660",
      aadharId: "951441649792",
      address: "BIKNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722155",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/053c1d10-33c5-40b5-9d62-4478f5e5ca13-M-1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/36f052de-05a1-4644-8f63-4ce0bbfcc415-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b21c4234e0da6440ba02c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b2503234e0da6440ba0bf",
      playerId: 1147,
      playerName: "RAJDEEP CHOWDHURY ",
      playerNickName: "Rajdeep",
      dob: "1994-03-03T00:00:00.000Z",
      weight: "82",
      height: "5.11",
      tShirtSize: "xxl",
      mobile: "6296311068",
      aadharId: "518537851038",
      address: "Ampahari",
      district: "Bankura",
      state: "WB",
      pinCode: "722137",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c85eaadd-8732-461a-b3f7-07859a802fef-IMG-20250130-WA0021.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8c6bedb7-e72a-4e9e-955b-faa292341360-Screenshot_20250130_123159_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b2503234e0da6440ba0c0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b2ce39f41d4c5a9129d2f",
      playerId: 1148,
      playerName: "Mubarak Ansary ",
      playerNickName: "Mubi",
      dob: "1992-08-11T00:00:00.000Z",
      weight: "63",
      height: "5,3",
      tShirtSize: "l",
      mobile: "6295436653",
      aadharId: "767375929552",
      address: "Raibandh",
      district: "Purulia",
      state: "WB",
      pinCode: "723133",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/394585bb-c002-4d50-9fc5-febd3fd81609-inbound8245924474001055698.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3721003c-f361-43b6-8321-948a8b77a3d7-inbound1821509592537778830.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b2ce39f41d4c5a9129d30",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b3cdd7c2b65b6fb1064b3",
      playerId: 1149,
      playerName: "AVIJIT KARMAKAR",
      playerNickName: "Avi",
      dob: "1993-12-04T00:00:00.000Z",
      weight: "82 kg",
      height: "6ft",
      tShirtSize: "xl",
      mobile: "6296102453",
      aadharId: "987641092553",
      address: "Kantaranguni",
      district: "Adra",
      state: "WB",
      pinCode: "723121",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3d3fe9ec-4cff-47ee-92c9-b1dd2b1eb4d6-Screenshot_2024-12-24-09-33-30-80_6012fa4d4ddec268fc5c7112cbb265e7.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/fde3aeb3-b063-4fe7-bf4b-5906ab6e85ce-Screenshot_2025-01-30-14-17-32-84_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b3cdd7c2b65b6fb1064b4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b3ecd7c2b65b6fb1064b9",
      playerId: 1150,
      playerName: "Dhiren Chatterjee ",
      playerNickName: "DHIRU",
      dob: "2003-09-19T00:00:00.000Z",
      weight: "55 kg",
      height: "5.7 inch ",
      tShirtSize: "m",
      mobile: "9883256207",
      aadharId: "244353895159",
      address: "Mamurjore ",
      district: "Purulia ",
      state: "WB",
      pinCode: "723126",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/88ae8735-addf-4c4a-84e2-bd70f3613d55-IMG_20240811_175201.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/965aed1a-3210-437c-b40d-2ed4842e1452-Screenshot_20250130-135146.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b3ecd7c2b65b6fb1064ba",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b419a7c2b65b6fb1064bf",
      playerId: 1151,
      playerName: "TUSHAR ",
      playerNickName: "TUSHAR ",
      dob: "1999-01-02T00:00:00.000Z",
      weight: "70",
      height: "5'11\"",
      tShirtSize: "m",
      mobile: "9641903854",
      aadharId: "919064427925",
      address: "Mantumra",
      district: "Bankura ",
      state: "WB",
      pinCode: "722137",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8eafe3ba-40cc-42b7-bdbd-24f6a947933c-1000059454.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/89dc94fe-394b-4d81-9825-379abd1bd42a-Screenshot_20250130_143808.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b419a7c2b65b6fb1064c0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b5865981299ba365d6242",
      playerId: 1152,
      playerName: "Bibek ",
      playerNickName: "Pa",
      dob: "1993-06-22T00:00:00.000Z",
      weight: "56",
      height: "5'6",
      tShirtSize: "m",
      mobile: "7001322946",
      aadharId: "951275437924",
      address: "Gobindanagar",
      district: "Bankura ",
      state: "WB",
      pinCode: "722102",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1212e120-db1a-409a-99c9-890485e9bb30-20230218_174051.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f1aea4f8-a9c0-4fa6-85bf-33b57432d6a0-Screenshot_20250130_160934_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b5865981299ba365d6243",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b5ca462012dfa32d04f24",
      playerId: 1153,
      playerName: "Sk parvej",
      playerNickName: "Raj",
      dob: "1989-12-23T00:00:00.000Z",
      weight: "65",
      height: "5'8",
      tShirtSize: "l",
      mobile: "+918759978887",
      aadharId: "933156841828",
      address: "Idgamalla ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722101",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d9624ff1-426f-4b8e-bbed-bf2b0a2941ea-IMG-20250130-WA0005.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/bfcdaa3e-4603-4ac4-8013-cfa18a387dfb-Screenshot_20250130_162402_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b5ca462012dfa32d04f25",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b6674246221624052a010",
      playerId: 1154,
      playerName: "Pathik mukherjee",
      playerNickName: "Babul",
      dob: "1993-04-07T00:00:00.000Z",
      weight: "63kg",
      height: "5'7''",
      tShirtSize: "l",
      mobile: "7031136997",
      aadharId: "746302540150",
      address: "Hamirhati-Sonamukhi",
      district: "Bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/41e62d74-6c92-4320-b4fd-4a70686bed1c-IMG_20231126_165512.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/08d10799-5b5c-4051-b207-3207be447d98-Screenshot_20250129_203254.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b6674246221624052a011",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b771239a30b9f2e3aca80",
      playerId: 1155,
      playerName: "Supriya Chakraborty",
      playerNickName: "KALU",
      dob: "1993-02-25T00:00:00.000Z",
      weight: "52",
      height: "5'6\"",
      tShirtSize: "m",
      mobile: "8918990245",
      aadharId: "919473943036",
      address: "BELIYATORE",
      district: "BANKURA",
      state: "WB",
      pinCode: "722203",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/36226671-2898-41c2-a88f-8f8423c9e303-KALU.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8a3d7474-8283-4a35-85b3-627cba389859-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b771239a30b9f2e3aca81",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b7bda39a30b9f2e3acd7c",
      playerId: 1156,
      playerName: "TAPAS AICH",
      playerNickName: "KALU",
      dob: "1991-07-24T00:00:00.000Z",
      weight: "70 Kg",
      height: "169 cm",
      tShirtSize: "m",
      mobile: "9564682940",
      aadharId: "474885850806",
      address: "ICHHARIA-SONAMUKHI",
      district: "BANKURA",
      state: "WB",
      pinCode: "722157",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/db663ed5-bcf9-4eae-9f95-7f55fe093e27-Screenshot_20250130-184503_Gallery.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/46fba6a5-e87b-4a38-82d1-f024cbe6ae29-Screenshot_20250130-184047_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b7bda39a30b9f2e3acd7d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b7cbd39a30b9f2e3aceb5",
      playerId: 1157,
      playerName: "Dolan Pal",
      playerNickName: "DOLU",
      dob: "2003-03-19T00:00:00.000Z",
      weight: "60",
      height: "5.7 feet",
      tShirtSize: "m",
      mobile: "8944097023",
      aadharId: "290868914232",
      address: "Beliatore",
      district: "Bankura",
      state: "WB",
      pinCode: "722203",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4d77c62b-c0f4-4c92-bb4b-40533a94a789-1000268024.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cc95eab2-c6dc-4276-a53d-defee6c0fe96-Screenshot_2025-01-30-18-44-49-01_49b96b5fbae0d12a18edc4a3afe0dfd9.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b7cbd39a30b9f2e3aceb6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b7e1b39a30b9f2e3acff0",
      playerId: 1158,
      playerName: "Snehasis chakraborty ",
      playerNickName: "Snehasis ",
      dob: "2003-02-03T00:00:00.000Z",
      weight: "60",
      height: '5"2',
      tShirtSize: "m",
      mobile: "6295662978",
      aadharId: "640946559942",
      address: "BISHNUPUR ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722122",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/079841bb-3235-42c6-8e2f-ed44d7f562db-1728220621368.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9096b1a0-a0b1-450f-82a7-a33e50344c21-IMG-20250130-WA0002.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b7e1b39a30b9f2e3acff1",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b80b439a30b9f2e3ad12d",
      playerId: 1159,
      playerName: "Sobur Ali Mondal",
      playerNickName: "Sobur",
      dob: "1999-05-04T00:00:00.000Z",
      weight: "57kg",
      height: "5 feet 5 inch",
      tShirtSize: "m",
      mobile: "8927159139",
      aadharId: "925922645113",
      address: "Kharkata",
      district: "Bankura ",
      state: "WB",
      pinCode: "722164",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/23513dd3-88f6-4702-87f3-950848de4e9f-1000218291.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/07c1388c-fde4-422c-b50c-df9bde137942-Screenshot_20250130-190129.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b80b439a30b9f2e3ad12e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b867c39a30b9f2e3ad3a2",
      playerId: 1160,
      playerName: "GANESH MAL",
      playerNickName: "GANESH ",
      dob: "2004-07-07T00:00:00.000Z",
      weight: "51 kg",
      height: "5 feet 2 inches",
      tShirtSize: "m",
      mobile: "9932922496",
      aadharId: "235634890768",
      address: "Susunia",
      district: "Bankura ",
      state: "WB",
      pinCode: "722182",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f1865bf6-c542-4cb9-9d2f-eb048dbaa5c0-1725289664726.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0c3983da-4b3d-402f-89fc-e08384ca451f-Screenshot_2025-01-30-19-07-48-977_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b867c39a30b9f2e3ad3a3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b89d539a30b9f2e3ad753",
      playerId: 1161,
      playerName: "Rocky Ghosh ",
      playerNickName: "Rocky ",
      dob: "2003-09-08T00:00:00.000Z",
      weight: "68 kg",
      height: "5 F 9 inch",
      tShirtSize: "l",
      mobile: "8695289616",
      aadharId: "555616843283",
      address: "Khosalpur-Patrasayer",
      district: "Bankura ",
      state: "WB",
      pinCode: "722206",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/407286e1-4b37-4c2f-a0c0-290b0f9e909a-1000333516.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/318d5ae3-f51f-4832-8820-93f3d09891c7-Screenshot_2025-01-30-19-41-39-84_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b89d539a30b9f2e3ad754",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b8a0b39a30b9f2e3ad759",
      playerId: 1162,
      playerName: "PINTU KAIBARTA",
      playerNickName: "PINTU KAIBARTA",
      dob: "1997-01-18T00:00:00.000Z",
      weight: "70",
      height: "5.8",
      tShirtSize: "l",
      mobile: "8617529919",
      aadharId: "2104 1860 4991",
      address: "PANDUA",
      district: "PURULIA ",
      state: "WB",
      pinCode: "723203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9f981f19-b853-4c41-a785-2b7141a0e4a4-1738244858153.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b04873fa-90ca-4095-8361-6debda3c8f5f-Screenshot_20250130-192442_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b8a0b39a30b9f2e3ad75a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b8a5c39a30b9f2e3ad75f",
      playerId: 1163,
      playerName: "AJOY DUTTA ",
      dob: "2000-01-19T00:00:00.000Z",
      weight: "70",
      height: "5/7",
      tShirtSize: "l",
      mobile: "9382547273",
      aadharId: "853824736193",
      address: "LAULARA",
      district: "Purulia ",
      state: "WB",
      pinCode: "723151",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b70db8d8-174a-493b-8ae0-31a45a506deb-IMG_20250130_193526.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/01c6319b-f0d7-4796-a8fc-783419a39a46-Screenshot_2025-01-30-19-20-04-04_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b8a5c39a30b9f2e3ad760",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b8ae139a30b9f2e3ad8ac",
      playerId: 1164,
      playerName: "asraful Ansary",
      playerNickName: "Asra",
      dob: "1998-01-07T00:00:00.000Z",
      weight: "60",
      height: "5.8 inch ",
      tShirtSize: "l",
      mobile: "8918502379",
      aadharId: "354896982647",
      address: "Bagalia",
      district: "Purulia ",
      state: "WB",
      pinCode: "723126",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/de30bccf-ae80-463a-b19c-fcd0d4495a94-inbound5326423813272928273.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/618048f5-30fb-4f9a-95da-201d42806304-inbound2222930089154750473.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b8ae139a30b9f2e3ad8ad",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b8d5439a30b9f2e3ad8b2",
      playerId: 1165,
      playerName: "Debdat ganguly ",
      playerNickName: "Pappu",
      dob: "1981-08-16T00:00:00.000Z",
      weight: "80",
      height: "5.7",
      tShirtSize: "xxl",
      mobile: "9932990666",
      aadharId: "353079094228",
      address: "Munsefdanga",
      district: "Purulia",
      state: "WB",
      pinCode: "723101",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a46d8db9-45f9-48ab-a02b-af0caca5954c-1000563747.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/653e4f21-cdf2-41c5-903c-4198f831c41f-IMG-20250130-WA0024.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b8d5439a30b9f2e3ad8b3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679b978d1a601f60149b71b8",
      playerId: 1166,
      playerName: "Amit Khedia",
      playerNickName: "Mickey",
      dob: "1988-09-05T00:00:00.000Z",
      weight: "70",
      height: "5'6\"",
      tShirtSize: "m",
      mobile: "9679626556",
      aadharId: "245426005326",
      address: "Ranchi Road",
      district: "Purulia ",
      state: "WB",
      pinCode: "723101",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2e02680d-459a-4807-81ae-5556b4ae876a-IMG-20250105-WA0019.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d5a37ed5-47fe-4e6e-a628-7aac9c925815-IMG-20250130-WA0045.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679b978d1a601f60149b71b9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679bad33eba7d0f184c4cea9",
      playerId: 1167,
      playerName: "Sandip dey",
      playerNickName: "Billu",
      dob: "1990-03-24T00:00:00.000Z",
      weight: "68",
      height: '5.9"',
      tShirtSize: "xl",
      mobile: "9635224937",
      aadharId: "8832 5779 6735",
      address: "Fullkhusma ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722162",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "offSpin",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/351a8e6b-f69e-4f10-9a46-d4a6b82f02ac-1000381674.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4139bf3b-f90e-4713-9f1d-3f2751fc0e0b-IMG-20250130-WA0009.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679bad33eba7d0f184c4ceaa",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679bb1844c6e62296942099f",
      playerId: 1168,
      playerName: "Partha Pratim Das ",
      playerNickName: "Ramu",
      dob: "2000-11-13T00:00:00.000Z",
      weight: "72",
      height: "5ft 10inch",
      tShirtSize: "l",
      mobile: "7797188052",
      aadharId: "492355499708",
      address: "Motgoda",
      district: "Bankura ",
      state: "WB",
      pinCode: "722134",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d21f2ec6-95f4-4127-b2e8-7ce8a34c177a-inbound6924721035203815045.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/60938928-f2d1-47ad-945f-7403114ba15f-inbound5157830498557218532.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679bb1844c6e6229694209a0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679bb1cd4c6e6229694209a5",
      playerId: 1169,
      playerName: "Soumyadeep Paul",
      playerNickName: "Tatai",
      dob: "2002-03-01T00:00:00.000Z",
      weight: "52",
      height: "4' 6\"",
      tShirtSize: "m",
      mobile: "7478599634",
      aadharId: "829343994591",
      address: "Upper Nadiha",
      district: "Purulia ",
      state: "WB",
      pinCode: "723102",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c48ed31f-4c52-487f-a322-040555450e16-1000157180.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f3d378f9-2138-4c82-a44f-b7f3348965b5-Screenshot_20250130_222638.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679bb1cd4c6e6229694209a6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679bde0fc98ab3e9cee85cd6",
      playerId: 1170,
      playerName: "Md Irfan",
      dob: "1992-03-15T00:00:00.000Z",
      weight: "90",
      height: "6ft",
      tShirtSize: "xl",
      mobile: "7908836941",
      aadharId: "753287251649",
      address: "Adra ",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/eadc23a9-af54-42c3-9420-7786d8bb2d58-inbound5250114192645670028.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/98eb4af4-0df2-4d22-8245-071b155a439d-inbound6976231884388360827.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679bde0fc98ab3e9cee85cd7",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c58e1a7f0a9717ab21006",
      playerId: 1171,
      playerName: "SOURAV CHAKRABORTY ",
      playerNickName: "Sourav",
      dob: "2002-02-06T00:00:00.000Z",
      weight: "68kg",
      height: "5 feet 6 inch",
      tShirtSize: "l",
      mobile: "9593512288",
      aadharId: "267432454329",
      address: "Talsagra-Patrasayer",
      district: "Bankura ",
      state: "WB",
      pinCode: "722206",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f1c29dbd-1df4-4972-93e7-f75ecfe51f65-1000161611.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8fed8d68-480d-406c-b5d6-213ca0c20e15-Screenshot_20250131-102459.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c58e1a7f0a9717ab21007",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c59d9a7f0a9717ab210b3",
      playerId: 1172,
      playerName: "Abhishek khan",
      playerNickName: "Bullet ",
      dob: "1992-01-02T00:00:00.000Z",
      weight: "75kg",
      height: "5 ft9 inch",
      tShirtSize: "l",
      mobile: "+1917908557616",
      aadharId: "279952739150",
      address: "Kenduadihi",
      district: "Bankura ",
      state: "WB",
      pinCode: "722102",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5730799d-b019-49b6-9569-193403fc31d5-inbound6157941099995135664.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0bc2b01a-075d-456e-9165-a38013637080-inbound7323663030197301390.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c59d9a7f0a9717ab210b4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c5aa4a7f0a9717ab21161",
      playerId: 1173,
      playerName: "Asish karmamar",
      playerNickName: "Babai",
      dob: "2007-07-21T00:00:00.000Z",
      weight: "66 kg ",
      height: "5Ft 6inch ",
      tShirtSize: "m",
      mobile: "9339918291",
      aadharId: "756060236979",
      address: "MOLIAN-Hirbandh",
      district: "Bankura ",
      state: "WB",
      pinCode: "722136",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a65c3432-b5e5-43cd-87d3-6f3b9dbf7d8c-IMG-20250127-WA0030.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9df2fb14-967d-4d32-a078-d5e1527a26c2-Screenshot_2025-01-31-10-32-49-760_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c5aa4a7f0a9717ab21162",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c600ba7f0a9717ab218b3",
      playerId: 1174,
      playerName: "Jagannath deoghuria ",
      playerNickName: "Joga",
      dob: "1992-05-02T00:00:00.000Z",
      weight: "54",
      height: "5'7\"",
      tShirtSize: "m",
      mobile: "9564290609",
      aadharId: "930247740201",
      address: "G-ghati",
      district: "Bankura ",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/034f4715-e315-4e50-998f-bd6b900cc758-IMG_20240903_195420.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a3f33758-86eb-4b9e-94e8-6acca5d90b56-Screenshot_2025-01-31-11-00-01-070_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c600ba7f0a9717ab218b4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c6163a7f0a9717ab21c0e",
      playerId: 1175,
      playerName: "Chittaranjan haldar ",
      playerNickName: "Peta da ",
      dob: "1983-01-01T00:00:00.000Z",
      weight: "72Kg",
      height: "6Ft",
      tShirtSize: "l",
      mobile: " 62974 80278",
      aadharId: "834598470455",
      address: "Molian-Hirbandh ",
      district: "Bankura",
      state: "WB",
      pinCode: "722136",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/92c4fba6-4e0d-4ba4-853c-06ac57dd6dd1-IMG-20250131-WA0008.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a0801bb8-cdce-42fc-b8ed-56ba6ae39da2-Screenshot_2025-01-31-11-01-59-843_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c6163a7f0a9717ab21c0f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c63c1a7f0a9717ab22019",
      playerId: 1176,
      playerName: "Sahid ansary ",
      dob: "2006-05-01T00:00:00.000Z",
      weight: "55",
      height: "5.5",
      tShirtSize: "l",
      mobile: "8927862457",
      aadharId: "969865319730",
      address: "Dimdiha ",
      district: "Purulia ",
      state: "WB",
      pinCode: "723103",
      playerType: "battingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/0b9cc966-918c-4b21-81be-e58bf7a584c3-IMG_20250118_194956.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b7493774-ef21-49dc-a5df-d87d3cab3696-Screenshot_20250131_111233.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c63c1a7f0a9717ab2201a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c63e2a7f0a9717ab220cb",
      playerId: 1177,
      playerName: "Prasenjit Banerjee ",
      playerNickName: "Bappa",
      dob: "1996-04-04T00:00:00.000Z",
      weight: "74",
      height: "5'9",
      tShirtSize: "l",
      mobile: "8016535174",
      aadharId: "684242329709",
      address: "Raghunathpur",
      district: "Purulia ",
      state: "WB",
      pinCode: "723133",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8c5b8b9d-84d6-4da8-bff8-4a1f8959fe43-inbound3705014819424830316.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/441e237d-73d8-4144-9385-82c31592e07e-inbound4094706372941444824.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c63e2a7f0a9717ab220cc",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c6618a7f0a9717ab228f7",
      playerId: 1178,
      playerName: "Partha Kumbhakar ",
      playerNickName: "Partha",
      dob: "2004-09-26T00:00:00.000Z",
      weight: "50",
      height: "5.4",
      tShirtSize: "s",
      mobile: "7001439631",
      aadharId: "329536055514",
      address: "Fulberia",
      district: "Bankura",
      state: "WB",
      pinCode: "722202",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/446b123c-9796-481f-b1ef-faed6e0cae6a-1000109196.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d282a5f8-3ba6-4fc9-a16b-83c25727672f-Screenshot_20250131_112311.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c6618a7f0a9717ab228f8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c6663a7f0a9717ab228fd",
      playerId: 1179,
      playerName: "Prithiraj Mura",
      playerNickName: "Praj",
      dob: "2007-05-19T00:00:00.000Z",
      weight: "50",
      height: "5",
      tShirtSize: "l",
      mobile: "6294121884",
      aadharId: "548746916643",
      address: "Jhalda",
      district: "Purulia",
      state: "WB",
      pinCode: "723202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/49bc9a80-6997-4561-9958-2e3d6d90093b-1000017883.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/68b05df0-ce0b-45bc-b6c3-f6dcd17b375b-IMG-20250131-WA0001.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c6663a7f0a9717ab228fe",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c6897a7f0a9717ab229b2",
      playerId: 1180,
      playerName: "Biswajit Dey",
      playerNickName: "Debu",
      dob: "1984-02-22T00:00:00.000Z",
      weight: "80",
      height: "5'6",
      tShirtSize: "xl",
      mobile: "8001785258",
      aadharId: "919363786726",
      address: "Raghunathpur",
      district: "Purulia",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c09704be-5057-4da4-8900-9dca375c5008-inbound5194436764156932216.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9d823e60-0d03-465d-81c4-f391b4aa1a38-inbound3531700010394021857.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c6897a7f0a9717ab229b3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c69bda7f0a9717ab229b8",
      playerId: 1181,
      playerName: "Arindam Karar ",
      playerNickName: "Ari",
      dob: "1996-09-07T00:00:00.000Z",
      weight: "80 kg",
      height: "722202",
      tShirtSize: "l",
      mobile: "8617348831",
      aadharId: "533254945084",
      address: "Barjora",
      district: "Bankura ",
      state: "WB",
      pinCode: "722202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/105ee8c5-2342-48bf-9936-38fac3ddb033-inbound1116794363966975129.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/af76eb74-2195-41e6-9646-fe7444e01f0d-inbound4131623066561592834.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c69bda7f0a9717ab229b9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c6c9da7f0a9717ab22b20",
      playerId: 1182,
      playerName: "Rishav singh",
      playerNickName: "Karan ",
      dob: "2005-01-05T00:00:00.000Z",
      weight: "65",
      height: "5,9",
      tShirtSize: "l",
      mobile: "8388892922",
      aadharId: "674095233491",
      address: "Tiluri",
      district: "Bankura ",
      state: "WB",
      pinCode: "722153",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2e20ecb5-5440-4277-b9be-29c58e571d55-05EDF274-667B-4B1A-A267-DF27CF6C8BE9.jpeg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/99d82a53-c047-4510-a51c-864428297282-IMG_9121.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c6c9da7f0a9717ab22b21",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c704da7f0a9717ab2300d",
      playerId: 1183,
      playerName: "Sandip Kumar ",
      playerNickName: "Master",
      dob: "2002-11-10T00:00:00.000Z",
      weight: "72 ",
      height: "5ft10inch ",
      tShirtSize: "xl",
      mobile: "7908022060",
      aadharId: "425049783957",
      address: "Jhunjka",
      district: "Purulia ",
      state: "WB",
      pinCode: "723154",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/85f6df2f-1486-4324-8737-eb23291f8616-inbound6440790803195158749.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/329a2cc8-b9f0-4853-a605-563e861f671c-inbound213428223696144497.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c704da7f0a9717ab2300e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c712aa7f0a9717ab23179",
      playerId: 1184,
      playerName: "Avijit pal",
      playerNickName: "Pancham",
      dob: "2003-09-30T00:00:00.000Z",
      weight: "90 kg",
      height: "6 foot",
      tShirtSize: "xxl",
      mobile: "9641583213",
      aadharId: "689093373631",
      address: "Hat ashuria",
      district: "Bankura",
      state: "WB",
      pinCode: "722204",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/316f24bc-15e2-428b-a58c-5610fdb68c07-1000058089.webp",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/208b3634-a841-4c0b-aac5-96dce0d7c4aa-Screenshot_20250131-121314.PhonePe.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c712aa7f0a9717ab2317a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c7157a7f0a9717ab2317f",
      playerId: 1185,
      playerName: "Abdul Bari Middya ",
      playerNickName: "Dalu",
      dob: "2006-01-05T00:00:00.000Z",
      weight: "67",
      height: "5.9",
      tShirtSize: "l",
      mobile: "9142280377",
      aadharId: "590890713963",
      address: "Papurdihi",
      district: "Bankura ",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/64950256-10e3-4ff3-89c1-f4df280fbe1f-1000246792.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/96a384b3-6f72-4627-a855-602d247e0c95-Screenshot_2025-01-31-12-10-11-91_62126bfb2f1f11d3d1500551279358f0.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c7157a7f0a9717ab23180",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c71a8a7f0a9717ab2323a",
      playerId: 1186,
      playerName: "Partha Sarathi Banerjee",
      playerNickName: "Partha",
      dob: "1981-09-27T00:00:00.000Z",
      weight: "65 kg",
      height: "5'7\"",
      tShirtSize: "xl",
      mobile: "7029449121",
      aadharId: "834827214480",
      address: "Simlabandh-Hirbandh",
      district: "Bankura",
      state: "WB",
      pinCode: "722101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8e4eb109-751e-4578-8cce-6bc015b61c9f-IMG-20250105-WA0005.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9bf296cd-9a08-4be3-93f3-b54f482c2b17-Screenshot_20250131_120058.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c71a8a7f0a9717ab2323b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c7dab84c94bbd5613584c",
      playerId: 1187,
      playerName: "Sujauddin mandal ",
      playerNickName: "Suja",
      dob: "1996-04-18T00:00:00.000Z",
      weight: "78",
      height: "6",
      tShirtSize: "xl",
      mobile: "9593700218",
      aadharId: "208512140932",
      address: "KUSHADWIP-PATRASAYER",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9eb7cad3-389f-4da8-9fce-dcf781531915-IMG_20241216_192537.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cbe9ca00-0356-43e9-9d64-7f4a7923ffca-Screenshot_2025-01-31-13-06-11-24_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c7dab84c94bbd5613584d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c7e2184c94bbd56135852",
      playerId: 1188,
      playerName: "SOUMALYA HALDAR",
      playerNickName: "SOUM",
      dob: "1988-05-14T00:00:00.000Z",
      weight: "72",
      height: "6",
      tShirtSize: "xl",
      mobile: "09732808811",
      aadharId: "764656271556",
      address: "Jhantipahari",
      district: "Bankura",
      state: "WB",
      pinCode: "722137",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e65148c6-5c84-45df-baec-7326b1e0a798-19406.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a1957efc-24dd-4779-9410-b4638a4b66da-Screenshot_2025-01-31-13-08-13-23_204a3e7a56d80833934821a7ecffdc0a.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c7e2184c94bbd56135853",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c87b8ada53316b44737c4",
      playerId: 1189,
      playerName: "Avijit biswas",
      playerNickName: "Roki",
      dob: "2004-06-02T00:00:00.000Z",
      weight: "52",
      height: "5'2",
      tShirtSize: "m",
      mobile: "9332300468",
      aadharId: "537600896326",
      address: "Morar",
      district: "Bankura ",
      state: "WB",
      pinCode: "722164",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c5e72f4f-cdf9-490e-acac-0fccbc144a3c-inbound3194840676036602396.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/978ab10f-0169-4e00-925d-e15d99ab2b5d-inbound3433991360424828249.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c87b8ada53316b44737c5",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c8856ada53316b44737ca",
      playerId: 1190,
      playerName: "Tapas Deb",
      playerNickName: "Mithun",
      dob: "1987-07-01T00:00:00.000Z",
      weight: "57 kg",
      height: "5.1'",
      tShirtSize: "m",
      mobile: "8617818939",
      aadharId: "825043845858",
      address: "ADRA",
      district: "Puruliya ",
      state: "WB",
      pinCode: "723121",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1313cb22-79cd-4001-a4d4-70ede0877667-inbound2445817273165452245.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4e4a616b-4589-4b4f-b03e-3394401267a7-inbound3718881066291478691.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c8856ada53316b44737cb",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c88d6ada53316b44737d0",
      playerId: 1191,
      playerName: "Manajit Tikadar",
      playerNickName: "Mono",
      dob: "2006-07-20T00:00:00.000Z",
      weight: "58",
      height: "5'9",
      tShirtSize: "m",
      mobile: "9064616345",
      aadharId: "785874912467",
      address: "Morar",
      district: "Bankura",
      state: "WB",
      pinCode: "722164",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/17689b97-c21f-456b-9fac-928418f90bb0-inbound4172991810247272531.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/410599a8-8962-4ca3-8d73-60823e64b69b-inbound2446457306075395791.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c88d6ada53316b44737d1",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c929cada53316b4473c38",
      playerId: 1192,
      playerName: "PARAN BAURI",
      playerNickName: "Pori",
      dob: "1992-01-05T00:00:00.000Z",
      weight: "54",
      height: "5'5",
      tShirtSize: "m",
      mobile: "6295403363",
      aadharId: "651116180026",
      address: "Deoli",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9ceb6461-4a24-4b2c-affd-57e8f0bb617f-inbound2436431133338431067.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/824cc877-41d7-4086-8bd2-1f8bf8c94f98-inbound5302308333993433812.pdf",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c929cada53316b4473c39",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c94fdada53316b4473c3e",
      playerId: 1193,
      playerName: "Sayan Karmakar",
      playerNickName: "Raydu",
      dob: "2002-06-27T00:00:00.000Z",
      weight: "87 kg",
      height: "5.7",
      tShirtSize: "xl",
      mobile: "07047009822",
      aadharId: "605683767129",
      address: "Kenjakura",
      district: "Bankura",
      state: "WB",
      pinCode: "722139",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4956bb73-b260-4725-997f-376747b15139-1000548012.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b3ef6500-0bab-472e-9191-87b9cd14dbbd-Screenshot_2025-01-31-14-43-48-90_4336b74596784d9a2aa81f87c2016f50.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c94fdada53316b4473c3f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679c9661ada53316b4473c44",
      playerId: 1194,
      playerName: "Sailen Bauri",
      playerNickName: "Sailen",
      dob: "2004-10-03T00:00:00.000Z",
      weight: "56",
      height: "5 feet 5 inches ",
      tShirtSize: "m",
      mobile: "9064274742",
      aadharId: "8524 8494 3029",
      address: "KENJAKURA ",
      district: "BANKURA",
      state: "WB",
      pinCode: "722139",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/51b9a42b-5d14-4cea-9fcd-580f78fe42d7-1000284247.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/befc6ead-d667-4737-bb4c-c36fbe49c49d-Screenshot_2025-01-31-14-46-47-778_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679c9661ada53316b4473c45",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cacc60fc1b391400649ec",
      playerId: 1195,
      playerName: "JOY BHAKAT ",
      playerNickName: "JOY",
      dob: "1995-01-16T00:00:00.000Z",
      weight: "74",
      height: "5'6\"",
      tShirtSize: "l",
      mobile: "8013375174",
      aadharId: "700199214041",
      address: "Lokepur ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722102",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "offSpin",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f1997860-ce58-4b14-8384-0650b3c75663-inbound3207633884400734539.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/dd8953be-d149-4111-8c99-3d49788b5eeb-inbound5663773833457512487.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cacc60fc1b391400649ed",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cb29f3bbcce4e680f1198",
      playerId: 1196,
      playerName: "RITESH Dutta ",
      playerNickName: "Gona",
      dob: "2003-01-23T00:00:00.000Z",
      weight: "65",
      height: "5.6 inch ",
      tShirtSize: "xxl",
      mobile: "8167441726",
      aadharId: "687224476796",
      address: "Susunia ",
      district: "BANKURA ",
      state: "WB",
      pinCode: "722182",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/329eb6a6-82f9-489b-b070-74646d313309-inbound2905951413796464581.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/464a6183-1ce8-42ee-97f2-ad24fdcb3bf7-inbound3549529456401828309.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cb29f3bbcce4e680f1199",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cc6a061b9ca79657fc5c2",
      playerId: 1197,
      playerName: "Nilu Bangal",
      dob: "1993-03-14T00:00:00.000Z",
      weight: "66",
      height: "5'10\"",
      tShirtSize: "l",
      mobile: "8918947348",
      aadharId: "903086337378",
      address: "Kadmaghati ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722155",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/0c0cbd9e-2854-4cea-bdc5-56c442d5813b-IMG-20250131-WA0005.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/84219499-dcb4-4887-9a68-4a20bd0582ad-Screenshot_2025-01-31-18-17-00-178_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cc6a061b9ca79657fc5c3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cc74661b9ca79657fc74d",
      playerId: 1198,
      playerName: "Prakash Prasad ",
      playerNickName: "Bhutan ",
      dob: "1992-04-30T00:00:00.000Z",
      weight: "70",
      height: "5.8",
      tShirtSize: "m",
      mobile: "7001358658",
      aadharId: "936535567241",
      address: "Adra",
      district: "Purulia",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/6fd49c50-59fc-4427-a29b-b7fb3abc0247-1000033402.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8926b73a-e677-4718-af82-63b4252acb47-IMG-20250131-WA0015.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cc74661b9ca79657fc74e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cc9c561b9ca79657fca5e",
      playerId: 1199,
      playerName: "Sanju Chowdhury ",
      playerNickName: "Pandey ",
      dob: "2000-09-24T00:00:00.000Z",
      weight: "72",
      height: "6",
      tShirtSize: "xl",
      mobile: "8250628924",
      aadharId: "843409732456",
      address: "Indas",
      district: "Bankura ",
      state: "WB",
      pinCode: "722205",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a6d89621-fb4f-4ff2-82c2-18ae23924d8a-Screenshot_2024-12-19-16-18-00-106_com.facebook.orca.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4ad71514-26a6-4510-beff-6856aef3a4c1-Screenshot_2025-01-31-18-20-03-293_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cc9c561b9ca79657fca5f",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cca4e61b9ca79657fca64",
      playerId: 1200,
      playerName: " Shibu Mal",
      playerNickName: "BAPPA",
      dob: "1999-09-15T00:00:00.000Z",
      weight: "65",
      height: "5'-7\"",
      tShirtSize: "l",
      mobile: "90642 67238",
      aadharId: "502305053549",
      address: "SALTORA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722143",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/25b057d0-3d61-4b37-ad12-968c79efd7f5-MAL.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f84385fc-c6f2-4e06-89c3-9915eef82206-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cca4e61b9ca79657fca65",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679ccd5061b9ca79657fcd80",
      playerId: 1201,
      playerName: "Debasis Banerjee ",
      playerNickName: "Riju ",
      dob: "1994-11-12T00:00:00.000Z",
      weight: "80",
      height: "5.10",
      tShirtSize: "xxl",
      mobile: "7908366006",
      aadharId: "721552955329",
      address: "Adra ",
      district: "Purulia",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/434355f2-dc31-4875-ac63-dcc06fe12e0e-1000019222.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0ff974ec-a371-4e89-ad21-fe78f160b886-IMG-20250131-WA0018.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679ccd5061b9ca79657fcd81",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cce9161b9ca79657fd09d",
      playerId: 1202,
      playerName: "RAKESH KARMAKAR ",
      playerNickName: "Rakesh",
      dob: "2000-08-09T00:00:00.000Z",
      weight: "77",
      height: "6",
      tShirtSize: "l",
      mobile: "9002546857",
      aadharId: "571490604460",
      address: "Gogra",
      district: "Bankura ",
      state: "WB",
      pinCode: "722137",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/468c5d2a-b28b-4692-b68c-cdefbea46ba6-inbound302350341702415493.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/c61dd958-bdd2-4782-95f1-7a7b438fb196-inbound8692744263215530810.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cce9161b9ca79657fd09e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cd0ff61b9ca79657fd0a3",
      playerId: 1203,
      playerName: "Patit Patra",
      playerNickName: "Patit",
      dob: "2003-06-10T00:00:00.000Z",
      weight: "55",
      height: "5.5",
      tShirtSize: "l",
      mobile: "9002442890",
      aadharId: "584196598062",
      address: "Sarenga",
      district: "Bankura ",
      state: "WB",
      pinCode: "722150",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/892271c2-1c26-4bf2-8e4c-887deb9af113-inbound3845115233097331039.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9f0c0bdf-c61b-46c0-bd89-6f46e3ecb4c5-inbound9154964427119632613.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cd0ff61b9ca79657fd0a4",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cd3e961b9ca79657fd3cb",
      playerId: 1204,
      playerName: "Debasis Das",
      playerNickName: "Deba",
      dob: "1995-09-11T00:00:00.000Z",
      weight: "82",
      height: "5.9",
      tShirtSize: "xl",
      mobile: "9064567361",
      aadharId: "583503561803",
      address: "Saltora",
      district: "Bankura ",
      state: "WB",
      pinCode: "722158",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/87d6fd50-27d6-4205-812a-dea66318b5f6-IMG_5843.jpeg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6b091496-cb76-4a55-9d80-5888d3617f8a-IMG_6411.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cd3e961b9ca79657fd3cc",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cd4bb61b9ca79657fd3d1",
      playerId: 1205,
      playerName: "Debabrata maji",
      playerNickName: "Bultus",
      dob: "2003-10-04T00:00:00.000Z",
      weight: "56",
      height: "5.9",
      tShirtSize: "l",
      mobile: "9882473150",
      aadharId: "695779265092",
      address: "MTPS",
      district: "Bankura",
      state: "WB",
      pinCode: "722183",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3758d68c-ca2d-4235-8f8b-54c36b5733aa-IMG_20241215_145748_996.webp",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3cc314b5-b2f2-415b-91b9-336556b5ec2f-Screenshot_2025-01-31-19-12-50-003_net.one97.paytm.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cd4bb61b9ca79657fd3d2",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cd5a861b9ca79657fd3d7",
      playerId: 1206,
      playerName: "Biplab saren ",
      playerNickName: "Baban",
      dob: "2001-01-26T00:00:00.000Z",
      weight: "68",
      height: "5,9",
      tShirtSize: "l",
      mobile: " 6295 958 105",
      aadharId: "329076181110",
      address: "Tiluri ",
      district: "Bankura",
      state: "WB",
      pinCode: "722153",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/66056ad3-dbc0-4838-a679-589a0918df49-inbound5764511201191838919.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e1abef79-06cf-4081-85ec-e1ccec26da59-inbound4443664117204808340.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cd5a861b9ca79657fd3d8",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cd5af61b9ca79657fd3dd",
      playerId: 1207,
      playerName: "SANJOY KARMAKAR",
      playerNickName: "SANJOY",
      dob: "1998-01-03T00:00:00.000Z",
      weight: "65",
      height: "5'6\"",
      tShirtSize: "m",
      mobile: "8250602329",
      aadharId: "443386778770",
      address: "GHUTGORIA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722168",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d1586e76-996c-428c-a8a0-5a03edac1c71-SAN-1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/87f14e9c-fd68-4e7a-969f-d851f1c1c9b0-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cd5af61b9ca79657fd3de",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cd6bc61b9ca79657fd64a",
      playerId: 1208,
      playerName: "Riju singha",
      playerNickName: "Riju",
      dob: "2001-05-16T00:00:00.000Z",
      weight: "70",
      height: "5ft 8inch",
      tShirtSize: "l",
      mobile: "9083009568",
      aadharId: "250895176227",
      address: "Nabagram",
      district: "Bankura",
      state: "WB",
      pinCode: "722203",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ffb614ab-3347-41cb-9915-7675853cded8-1000395945.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/77f5de7b-3d3b-423d-a357-a91af47528c6-Screenshot_2025-01-31-19-24-34-28_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cd6bc61b9ca79657fd64b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cde897004db18544f2a23",
      playerId: 1209,
      playerName: "ABDUL ANSARY",
      playerNickName: "ABDUL",
      dob: "1996-02-06T00:00:00.000Z",
      weight: "72",
      height: "5'8\"",
      tShirtSize: "xl",
      mobile: "7477462954",
      aadharId: "904136660836",
      address: "PURULIA",
      district: "PURULIA",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8379f6ec-91a2-498a-b1fc-07c2b62eafc1-ABD.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d4bca7e8-e623-4d33-945e-b570fcfd8ceb-ARK-41.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cde897004db18544f2a24",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cdffe7004db18544f2d60",
      playerId: 1210,
      playerName: "Saif Ali Ansari ",
      playerNickName: "Saif",
      dob: "2001-03-26T00:00:00.000Z",
      weight: "85",
      height: "5.7",
      tShirtSize: "xl",
      mobile: "9932475901",
      aadharId: "591111893171",
      address: "Balarampur",
      district: "Purulia ",
      state: "WB",
      pinCode: "723143",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/afd08f97-460e-4ce3-b974-d4bba258b8fb-Screenshot_2024-12-18-23-10-15-310_com.instagram.android.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6a485dfb-4935-48ef-a7b9-525260c58e75-Screenshot_2025-01-31-20-05-32-904_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cdffe7004db18544f2d61",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679ce0167004db18544f2d66",
      playerId: 1211,
      playerName: "RIJU RAJAK",
      playerNickName: "RIJU",
      dob: "1996-03-02T00:00:00.000Z",
      weight: "80",
      height: "5'-10\"",
      tShirtSize: "l",
      mobile: "8918608886",
      aadharId: "855870011317",
      address: "NAPARA",
      district: "PURULIA",
      state: "WB",
      pinCode: "723151",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ac4c194a-6dfa-49bb-80a4-72c04c70d6be-RIJU-1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/341aa798-71bc-4035-863d-ac66bc6d84b6-ARK-41.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679ce0167004db18544f2d67",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679ce4b77004db18544f3657",
      playerId: 1212,
      playerName: "Saheb mishra ",
      playerNickName: "Saheb ",
      dob: "1994-02-21T00:00:00.000Z",
      weight: "85",
      height: "5.8",
      tShirtSize: "xl",
      mobile: "7865854019",
      aadharId: "598366722244",
      address: "Gangajal ghati",
      district: "Bankura ",
      state: "WB",
      pinCode: "722142",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/95857595-bec5-44b0-9077-0601bed7ab4e-IMG-20250126-WA0022.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/59a18522-828a-47be-9d6b-e3c99380668b-IMG-20250131-WA0006.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679ce4b77004db18544f3658",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679ce93d7004db18544f3a70",
      playerId: 1213,
      playerName: "Ajoy Rana ",
      dob: "1997-12-25T00:00:00.000Z",
      weight: "72",
      height: "5'6\"",
      tShirtSize: "l",
      mobile: "7908383934",
      aadharId: "608054623396",
      address: "Kanchanpur",
      district: "Bankura ",
      state: "WB",
      pinCode: "722155",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/71c26d6c-f548-4271-9f3a-b6ad6541a388-1000113199.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/7f2fdcd8-81ee-4aa9-8dcc-6f1fa18a8d6a-IMG-20250131-WA0014.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679ce93d7004db18544f3a71",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679ceb757004db18544f3a76",
      playerId: 1214,
      playerName: "Arjun patra ",
      playerNickName: "Ap",
      dob: "1997-09-27T00:00:00.000Z",
      weight: "64",
      height: "5'7",
      tShirtSize: "m",
      mobile: "917679869114",
      aadharId: "453911565737",
      address: "Joykrishnapur-Bishnupur",
      district: "Bankura",
      state: "WB",
      pinCode: "722122",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/dc3bb5e3-aac5-423b-8bd8-fddb3bee2aab-inbound442751135737941463.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3246192a-be92-432f-a0bc-d6a9349abff5-inbound6774818117650995817.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679ceb757004db18544f3a77",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cee287004db18544f3a7c",
      playerId: 1215,
      playerName: "Rahul Choudhury",
      playerNickName: "Rc",
      dob: "1998-01-31T00:00:00.000Z",
      weight: "65",
      height: "6",
      tShirtSize: "l",
      mobile: "8617871485",
      aadharId: "760484759109",
      address: "Ampahari",
      district: "Bankura",
      state: "WB",
      pinCode: "722137",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/240cdba5-23a1-4188-b235-9bbd603238ea-IMG-20250131-WA0053.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0a3e81d1-c85e-483e-98ad-afe29dfda891-IMG-20250131-WA0052.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cee287004db18544f3a7d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679cf91f979ad2bbcad2c63a",
      playerId: 1216,
      playerName: "Dilkhush rajak ",
      playerNickName: "Dilu",
      dob: "2006-11-10T00:00:00.000Z",
      weight: "58",
      height: '5"8',
      tShirtSize: "m",
      mobile: "+91 86373 22090",
      aadharId: "375014933757",
      address: "Simul bera post",
      district: "Purulia ",
      state: "WB",
      pinCode: "723103",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/66cfdc9d-a70e-49d7-950e-826442ea97d1-1000115333.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/37c034e8-0504-4596-9e5c-13c7411d0fbd-Screenshot_20250131-214832_PhonePe.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679cf91f979ad2bbcad2c63b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679d017853dcae0a95f9dbed",
      playerId: 1217,
      playerName: "Kunal singha",
      playerNickName: "Kunal ",
      dob: "1993-09-04T00:00:00.000Z",
      weight: "77",
      height: '5.11"',
      tShirtSize: "xl",
      mobile: "9800893478",
      aadharId: "529792459920",
      address: "Beliatore",
      district: "Bankura",
      state: "WB",
      pinCode: "722203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c9d681b1-36e1-43e9-8d52-1466a739ec36-1000111662.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5d0c540e-fc93-42c3-be8c-1eff5352d764-Screenshot_2025-01-31-22-20-43-34_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679d017853dcae0a95f9dbee",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679d03ed53dcae0a95f9dcc8",
      playerId: 1218,
      playerName: "INDRAJIT ROY",
      playerNickName: "Bachhu",
      dob: "1984-12-05T00:00:00.000Z",
      weight: "65",
      height: "5.4",
      tShirtSize: "m",
      mobile: "9564388242",
      aadharId: "4405 0304 4557",
      address: "Kadmaghati",
      district: "Bankura",
      state: "WB",
      pinCode: "722155",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/ae058b4f-2a77-4203-916c-f6c0e46ea49d-IMG-20250131-WA0002.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6913486c-c31f-43af-a910-9b6543a42c61-IMG-20250131-WA0001.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679d03ed53dcae0a95f9dcc9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679d0de51ef098b4318d61e9",
      playerId: 1219,
      playerName: "Ms Hossain ",
      playerNickName: "Rice ",
      dob: "2007-12-04T00:00:00.000Z",
      weight: "58",
      height: "5.7",
      tShirtSize: "m",
      mobile: "8918392357",
      aadharId: "648211066579",
      address: "Badulara ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722102",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1023d64c-4a28-4975-a7dc-5aa2ae1fafe8-1000042132.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/450b4fdd-5076-4e47-ab00-07c9da97df04-IMG-20250131-WA0005.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679d0de51ef098b4318d61ea",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679d9b838c16b35d88fb9e66",
      playerId: 1220,
      playerName: "Akash Dey",
      playerNickName: "Akash",
      dob: "2007-03-03T00:00:00.000Z",
      weight: "60kg",
      height: "5'5\"",
      tShirtSize: "m",
      mobile: "7031073037",
      aadharId: "805224767804",
      address: "Rajgram",
      district: "Bankura ",
      state: "WB",
      pinCode: "722146",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/307611ba-ee63-43cf-88d1-7f05880c5768-1000052933.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/ffd36556-33d9-4580-beb3-ee048b0ee454-Screenshot_20250201_091623.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679d9b838c16b35d88fb9e67",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679da6e07fb969de3490d119",
      playerId: 1221,
      playerName: "Indrajit Singha",
      playerNickName: "Indra",
      dob: "1992-07-19T00:00:00.000Z",
      weight: "75",
      height: "722101",
      tShirtSize: "l",
      mobile: "7908996018",
      aadharId: "247641551678",
      address: "School Danga",
      district: "Bankura",
      state: "WB",
      pinCode: "722101",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1e29508f-97b2-46fd-ab12-7bbfbfb736e6-inbound2093266654988485763.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f8457660-833c-4888-b2c5-3ffde7c6ad76-inbound5872154729218157750.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679da6e07fb969de3490d11a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679da6ee7fb969de3490d11f",
      playerId: 1222,
      playerName: "Achintyalayek ",
      playerNickName: "Jordan",
      dob: "1998-11-10T00:00:00.000Z",
      weight: "75",
      height: "6 ft",
      tShirtSize: "xl",
      mobile: "8637568485",
      aadharId: "589334829547",
      address: "MTPS",
      district: "Bankura",
      state: "WB",
      pinCode: "722183",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3e1826cc-de10-47a3-838d-23e51eb6b5b5-20250117_085557.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3948bf5c-d197-47a6-9c2f-2b25d9cf6464-IMG-20250201-WA0000.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679da6ee7fb969de3490d120",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679dbd89ab08a73cdbd1b76f",
      playerId: 1223,
      playerName: "CHIRANJIT CHAKRABORTY",
      playerNickName: "CHIRANJIT",
      dob: "1990-11-19T00:00:00.000Z",
      weight: "55",
      height: "5.7",
      tShirtSize: "xl",
      mobile: "7797578787",
      aadharId: "771331902540",
      address: "ONDA",
      district: "Bankura",
      state: "WB",
      pinCode: "722144",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/804da446-a82d-4309-adbf-544649d65583-1000261587.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0e0e9bc9-848b-4d1a-9df8-524308fe50ec-IMG-20250201-WA0091.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679dbd89ab08a73cdbd1b770",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e1739e1fb65790ee55731",
      playerId: 1224,
      playerName: "SUSOVAN PARAMANIK",
      playerNickName: "DIPU",
      dob: "1998-05-20T00:00:00.000Z",
      weight: "73",
      height: "5'7",
      tShirtSize: "l",
      mobile: "6296031456",
      aadharId: "242832033053",
      address: "TILURI",
      district: "BAKURA",
      state: "WB",
      pinCode: "722153",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d9763eca-8f81-4f06-ab05-311fe022ecef-DIPU.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1bd9ac98-b132-4e73-81dc-044e815d5268-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e1739e1fb65790ee55732",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e17e1e1fb65790ee55816",
      playerId: 1225,
      playerName: "Prakash Kshetrapal ",
      playerNickName: "Bapi",
      dob: "1984-01-02T00:00:00.000Z",
      weight: "70",
      height: "5ft 6 inch ",
      tShirtSize: "xl",
      mobile: "8250838955",
      aadharId: "335379110010",
      address: "Chhatna",
      district: "Bankura ",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3646a07c-14a2-4a44-ac2b-c056294e42a1-IMG_20240404_201331.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/ea8a57e9-6209-4b73-aeeb-d8b1c5a9203d-Screenshot_20250201_144918.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e17e1e1fb65790ee55817",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e19cce1fb65790ee55b93",
      playerId: 1226,
      playerName: "AMRIT DHIBAR",
      playerNickName: "AMRIT",
      dob: "2000-09-27T00:00:00.000Z",
      weight: "60",
      height: "5'-5\"",
      tShirtSize: "m",
      mobile: "7719297470",
      aadharId: "557642942552",
      address: "MANBAZAR",
      district: "PURULIA",
      state: "WB",
      pinCode: "723131",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/203ef204-0a66-4881-a0d4-ed192c1217f3-AMIT.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6307df78-86db-4ebf-96d5-f03255484b43-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e19cce1fb65790ee55b94",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e1af9e1fb65790ee55c7a",
      playerId: 1227,
      playerName: "ASIT MAHAT",
      playerNickName: "ASIT",
      dob: "2003-01-19T00:00:00.000Z",
      weight: "72",
      height: "5'-5\"",
      tShirtSize: "l",
      mobile: "7557034762",
      aadharId: "325105035129",
      address: "RANIBANDH",
      district: "BANKURA",
      state: "WB",
      pinCode: "722148",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/3a75f146-5b1a-4fee-9533-d65a6d4637ea-100.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/48bd696c-a360-4b28-9b6c-c76e3dfafe66-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e1af9e1fb65790ee55c7b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e1bd1e1fb65790ee55d5f",
      playerId: 1228,
      playerName: "BISHAL PATI",
      playerNickName: "BISHAL",
      dob: "2004-10-18T00:00:00.000Z",
      weight: "60",
      height: "5'-6\"",
      tShirtSize: "m",
      mobile: "6295197932",
      aadharId: "221399955380",
      address: "HATIRAMPUR",
      district: "BANKURA",
      state: "WB",
      pinCode: "722121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1f3fcce8-a90a-442e-a970-9b5e8db41a72-1010.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/2390adf1-b827-49cc-b868-2f299a4c3821-ARK-41.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e1bd1e1fb65790ee55d60",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e1d3ee1fb65790ee5600b",
      playerId: 1229,
      playerName: "BIPLOB MONDAL",
      playerNickName: "MASTER",
      dob: "1990-02-19T00:00:00.000Z",
      weight: "65",
      height: "5.7ft",
      tShirtSize: "m",
      mobile: "9735896798",
      aadharId: "942158680752",
      address: "Bikna",
      district: "Bankura",
      state: "WB",
      pinCode: "722155",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e42cc0c5-8dbb-453e-9b4a-cebf193084ba-IMG-20231226-WA0066.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/fb633dab-ec2c-4f83-82ce-ad534755e474-Screenshot_2025-02-01-18-13-53-516_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e1d3ee1fb65790ee5600c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e2058e1fb65790ee561d6",
      playerId: 1230,
      playerName: "Rudra Mukherjee ",
      playerNickName: "Labusen",
      dob: "2006-01-31T00:00:00.000Z",
      weight: "48KG",
      height: "5.4 FT",
      tShirtSize: "m",
      mobile: "93829 42848",
      aadharId: "781789642658",
      address: "Bagda",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "bowlingAllRounder",
      battingArm: "left",
      bowlingArm: "left",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5dd864fe-6c31-4668-9648-c2cafd6c6643-1000032867.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/3fcea55e-f436-49df-85a5-fce006601a10-IMG-20250201-WA0005.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e2058e1fb65790ee561d7",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e20bee1fb65790ee561dc",
      playerId: 1231,
      playerName: "Abhirup Singha ",
      playerNickName: "Abhi",
      dob: "2002-05-28T00:00:00.000Z",
      weight: "68",
      height: "5.8",
      tShirtSize: "l",
      mobile: "9382054816",
      aadharId: "949688333756",
      address: "Beliatore ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7611ba86-b98d-4877-b4b9-d116b49fb227-1000129203.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/14c871b9-bbd6-44ea-a89f-e3e4df2e8c85-IMG-20250201-WA0010.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e20bee1fb65790ee561dd",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e2111e1fb65790ee561e2",
      playerId: 1232,
      playerName: "Mir Sohel Ali",
      playerNickName: "SOHEL",
      dob: "1992-05-02T00:00:00.000Z",
      weight: "72",
      height: "5'7",
      tShirtSize: "l",
      mobile: "9679434653",
      aadharId: "471103628144",
      address: "KHATRA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722140",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/943536d1-b1a5-4cba-b602-569ace45e7d4-MIR.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/79f501d0-153c-45dd-b41b-6284a51c4608-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e2111e1fb65790ee561e3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e216ee1fb65790ee562d2",
      playerId: 1233,
      playerName: "Bijoy Mahato ",
      playerNickName: "Bubai",
      dob: "2007-03-19T00:00:00.000Z",
      weight: "50KG",
      height: "5.5FT",
      tShirtSize: "m",
      mobile: "7601846509",
      aadharId: "483941379965",
      address: "Rangadih",
      district: "Purulia ",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/eacda799-ec0e-493c-84a6-cea6a1cc70bd-1000020881.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e8e03ab1-5b8a-43eb-a3fa-772e20e96ded-IMG-20250201-WA0011.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e216ee1fb65790ee562d3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e226ae1fb65790ee563c0",
      playerId: 1234,
      playerName: "SOURAV DESHMUKH",
      playerNickName: "SOURAV",
      dob: "1983-07-08T00:00:00.000Z",
      weight: "72",
      height: "5'8\"",
      tShirtSize: "xl",
      mobile: "9734265325",
      aadharId: "249087022245",
      address: "ARRAH",
      district: "BANKURA",
      state: "WB",
      pinCode: "722137",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/65f6a341-ba25-4efd-af1c-6e79d9338a53-SD.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/81bf2f28-00bf-4792-b7e9-5265843c1905-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e226ae1fb65790ee563c1",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e23c1e1fb65790ee5684a",
      playerId: 1235,
      playerName: "Sourav saha ",
      playerNickName: "Sourav ",
      dob: "2000-01-26T00:00:00.000Z",
      weight: "65",
      height: "5'8",
      tShirtSize: "l",
      mobile: " 77977 82367",
      aadharId: "957351170999",
      address: "Taldangra",
      district: "Bankura ",
      state: "WB",
      pinCode: "722149",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/805267c0-5989-470f-9f1d-eca996e745c7-1000387624.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b5aae5e8-c84a-4f1d-8a3d-57bdb5d25b06-Screenshot_2025-02-01-19-01-51-329_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e23c1e1fb65790ee5684b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e27bee1fb65790ee56a21",
      playerId: 1236,
      playerName: "SOUMITRA CHATTERJEE",
      playerNickName: "SOUMITRA",
      dob: "1993-02-02T00:00:00.000Z",
      weight: "60",
      height: "5'7",
      tShirtSize: "l",
      mobile: "9933183319",
      aadharId: "464061007165",
      address: "CHHATANA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/59dc0aea-434c-48aa-bc5f-46e3fdfe6e9a-SOMITRA.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/c8ddddf6-4b68-4e46-8a04-54b80203d7e8-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e27bee1fb65790ee56a22",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e2a5ee1fb65790ee57082",
      playerId: 1237,
      playerName: "RANJAN SARKAR",
      playerNickName: "RANJAN",
      dob: "1991-02-07T00:00:00.000Z",
      weight: "72",
      height: "5'-8\"",
      tShirtSize: "xl",
      mobile: "8016171680",
      aadharId: "961408666158",
      address: "SONAMUKHI",
      district: "BANKURA",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a0f7407c-d278-492d-8390-0203b32aa9a7-RANJAN.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/61d4af17-0a06-423a-aad8-179d24fac6ed-WhatsApp%20Image%202024-12-20%20at%207.21.05%20PM.jpeg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e2a5ee1fb65790ee57083",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e2a8ce1fb65790ee5725d",
      playerId: 1238,
      playerName: "Suman Karmakar",
      playerNickName: "Ping",
      dob: "1992-01-19T00:00:00.000Z",
      weight: "57",
      height: "5",
      tShirtSize: "m",
      mobile: "8116753055",
      aadharId: "265211017113",
      address: "Susunia",
      district: "Bankura",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/804d8d00-70af-4416-82a8-04e0d75d162b-1000086140.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/bdfb19c7-1c43-4cc6-9233-9e15e63a4b4b-Screenshot_2025-02-01-19-36-38-90_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e2a8ce1fb65790ee5725e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "679e2afce1fb65790ee5743a",
      playerId: 1239,
      playerName: "Arijit rajak ",
      playerNickName: "Rana",
      dob: "2003-01-24T00:00:00.000Z",
      weight: "50",
      height: "5.8",
      tShirtSize: "m",
      mobile: "7478049335",
      aadharId: "740669458247",
      address: "Sonamukhi",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d20fdd2b-33ed-496e-80f9-aae7ae89aea6-IMG-20250201-WA0038.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/7a334144-1ef8-46f3-b701-5551ba92ecde-Screenshot_2025-02-01-19-38-41-940_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "679e2afce1fb65790ee5743b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aa0857c3cf82534153af1b",
      playerId: 1240,
      playerName: "Parthasarathi mahato",
      playerNickName: "Mental",
      dob: "1993-12-26T00:00:00.000Z",
      weight: "80 kg",
      height: "6ft",
      tShirtSize: "xl",
      mobile: "8617867211",
      aadharId: "595642500254",
      address: "kenda",
      district: "Purulia",
      state: "WB",
      pinCode: "723128",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7d706d0b-8b3d-4340-87b9-5dcb781f6042-IMG_20230620_104851.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/c8edb75f-fa9b-47c9-9c3c-33f5978662e7-Screenshot_2025-02-10-19-31-00-132_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aa0857c3cf82534153af1c",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aa189ec1fad9646de75fcc",
      playerId: 1241,
      playerName: "Arnab Chatterjee ",
      playerNickName: "Arnab",
      dob: "1993-10-30T00:00:00.000Z",
      weight: "74",
      height: "5'7\"",
      tShirtSize: "xl",
      mobile: "9476212928",
      aadharId: "541269921820",
      address: "Palasdanga ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722208",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/0d46f60d-446c-4a8f-b9ec-5419d8111536-inbound8311924250912948464.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8b824ec3-82f5-47a0-954b-e6b4a5e11e7c-inbound9054830146975583305.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aa189ec1fad9646de75fcd",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aa226248dabe19bf326659",
      playerId: 1243,
      playerName: "Biswajit karmakar ",
      playerNickName: "Bhaipo ",
      dob: "1991-05-04T00:00:00.000Z",
      weight: "59",
      height: "5.6 ",
      tShirtSize: "l",
      mobile: "863788574",
      aadharId: "478473698399",
      address: "Sonamukhi lalbazar ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2cc3dd4b-3e0e-4630-ac3a-f246a178dc86-1000039661.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f4ceb657-2ddc-4d0a-a37c-38eea90fbf95-Screenshot_20250210_212544_PhonePe.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aa226248dabe19bf32665a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aa262db203599e650db3a9",
      playerId: 1244,
      playerName: "Bikram Gorai ",
      dob: "2004-06-10T00:00:00.000Z",
      weight: "75kg",
      height: "5'6\"",
      tShirtSize: "xl",
      mobile: "7029799598",
      aadharId: "724067774535",
      address: "G Ghati, Salbedia ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722203",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/32f06450-270e-4608-b505-1bcf1771580d-IMG20240505120751.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d0cdffe3-0dd2-4ccb-8ca3-33daea6b9991-Screenshot_2025-02-10-21-21-39-654_com.google.android.apps.nbu.paisa.user.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aa262db203599e650db3aa",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aaf6c78076493cf897e063",
      playerId: 1245,
      playerName: "Akash Roy",
      dob: "1993-10-20T00:00:00.000Z",
      weight: "60kg",
      height: "5'7\"",
      tShirtSize: "l",
      mobile: "9679163190",
      aadharId: "482594517917",
      address: "Para",
      district: "Purulia",
      state: "WB",
      pinCode: "723155",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/16bfb901-f35d-43bf-acb1-2ac144af0dba-inbound1550126868203463411.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/50a7a806-f785-4de0-8de0-1f0dffe98279-inbound819102051453748181.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aaf6c78076493cf897e064",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ab36f4117761add7e19d62",
      playerId: 1246,
      playerName: "BUDDHADEV MONDAL ",
      playerNickName: "BUDDHA",
      dob: "1992-02-18T00:00:00.000Z",
      weight: "75",
      height: "170cm",
      tShirtSize: "xl",
      mobile: "7602316473",
      aadharId: "421582084995",
      address: "SHYAMPUR",
      district: "Bankura",
      state: "WB",
      pinCode: "722158",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/780149cc-fb25-45cb-9edc-6c62d1a91c08-17392736872654368864585689826694.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/23094d5f-6a70-4938-97d5-91b2d6231586-Screenshot_20250211_170819.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ab36f4117761add7e19d63",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ab4091db0cc5db67efe88c",
      playerId: 1247,
      playerName: "Ikon layek",
      dob: "2005-05-11T00:00:00.000Z",
      weight: "65kg",
      height: "5ft.11inch",
      tShirtSize: "l",
      mobile: "9641125429",
      aadharId: "708769408626",
      address: "Lokepur ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722102",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/25b52e8f-b918-4668-9b12-686ad296b8f6-1000019272.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9fd2b521-1494-4e71-86ec-e4c4865bbe7b-Screenshot_20250211_174550.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ab4091db0cc5db67efe88d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ab6c53891da738b5d1bc5f",
      playerId: 1249,
      playerName: "Indrajit Gorai ",
      playerNickName: "Raja",
      dob: "2008-02-26T00:00:00.000Z",
      weight: "54",
      height: "5.6",
      tShirtSize: "m",
      mobile: "8101090818",
      aadharId: "965617445673",
      address: "Tiluri ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722153",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/885f3e29-7442-44da-8510-313867b2d37c-1000162029.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/2e42ccad-37dc-4c84-b2b2-6c4c173e6045-Screenshot_20250211_205034.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ab6c53891da738b5d1bc60",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ab8eaecba7440414e49f51",
      playerId: 1250,
      playerName: "Animesh Karmakar",
      playerNickName: "Gopal",
      dob: "2005-07-19T00:00:00.000Z",
      weight: "70",
      height: "5.6",
      tShirtSize: "xl",
      mobile: "6295883947",
      aadharId: "380812729432",
      address: "Pakhanna, Barjora ",
      district: "Bankura",
      state: "WB",
      pinCode: "722208",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/b1cdd69c-d8cc-4c17-95a8-0407086c33ca-inbound3606113233627326192.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0961b07b-acd5-486a-bc2d-fb8bcbce56de-inbound8605623467232687693.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ab8eaecba7440414e49f52",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac2451b0ec604dcac187cc",
      playerId: 1251,
      playerName: "Pintu rajak ",
      playerNickName: "Pintu ",
      dob: "2005-08-07T00:00:00.000Z",
      weight: "56",
      height: '5"6',
      tShirtSize: "m",
      mobile: "8509367219",
      aadharId: "564312068663",
      address: "Simul bera",
      district: "Purulia ",
      state: "WB",
      pinCode: "723103",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9fd37b7e-7bf8-448f-ae19-6a9f884a217d-1000122589.png",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/58f0722a-f5fe-4e3d-9e4b-3b4aab77e971-Screenshot_20250211-201109_PhonePe.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac2451b0ec604dcac187cd",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac24f2b0ec604dcac187d2",
      playerId: 1252,
      playerName: "ABINASH MAHATO ",
      playerNickName: "Abhi",
      dob: "1995-05-24T00:00:00.000Z",
      weight: "53",
      height: "5ft 5in",
      tShirtSize: "m",
      mobile: "6297545091",
      aadharId: "489926998704",
      address: "Hura",
      district: "Purulia ",
      state: "WB",
      pinCode: "7231458",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/de13c0ad-c94f-4e83-b2fc-0a670ce15806-inbound9021662156945750279.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/ed81fb6a-916e-454f-ab04-0f663aed8d78-inbound1769557478014578984.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac24f2b0ec604dcac187d3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac3fa021de25a4676aca7c",
      playerId: 1253,
      playerName: "Ranit Pal",
      playerNickName: "Rony",
      dob: "2004-08-02T00:00:00.000Z",
      weight: "80",
      height: "6",
      tShirtSize: "xxl",
      mobile: "9832632048",
      aadharId: "5667 2675 7710",
      address: "Baralal pur",
      district: "Bankura",
      state: "WB",
      pinCode: "722142",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/481b5c86-0e36-45fa-80a7-1b48ffe022e3-inbound2123227210352294461.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/93f08cc3-aefd-427b-b931-c558e4984dfd-inbound5394047154148626544.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac3fa021de25a4676aca7d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac4fd8ddae6ea2ce13c2d4",
      playerId: 1254,
      playerName: "Rahul Ganguli",
      playerNickName: "Ganguli",
      dob: "2005-11-12T00:00:00.000Z",
      weight: "52",
      height: "5.4",
      tShirtSize: "m",
      mobile: "9800551526",
      aadharId: "348791025778",
      address: "boram",
      district: "purulia",
      state: "WB",
      pinCode: "723201",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/73dacad9-54a6-4b45-9d02-dde595de941d-1739345662690.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/898f612f-c77f-45da-9080-9f6f02cd6f0a-Screenshot_2025-02-12-12-59-00-584_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac4fd8ddae6ea2ce13c2d5",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac71507c8cbd109fc066e8",
      playerId: 1255,
      playerName: "Pratyush Banerjee",
      playerNickName: "Gullu",
      dob: "2003-12-06T00:00:00.000Z",
      weight: "65",
      height: "5ft 10 inch. ",
      tShirtSize: "m",
      mobile: "8918007539",
      aadharId: "777488877467",
      address: "Junbedia",
      district: "Bankura",
      state: "WB",
      pinCode: "722101",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/51ac4657-77d4-4f2d-8ec5-7070b16598a8-IMG_20250119_120156.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4b594ffe-7fe2-47de-9e06-882183c28a18-Screenshot_2025-02-12-15-27-08-557_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac71507c8cbd109fc066e9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac9480f6bf2dbc74c5426d",
      playerId: 1256,
      playerName: "Partha Paramanik",
      playerNickName: "Partha",
      dob: "2007-03-24T00:00:00.000Z",
      weight: "45",
      height: "5.2",
      tShirtSize: "m",
      mobile: "8967975759",
      aadharId: "743349385808",
      address: "Joysinghapur-Chousal ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722142",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/02daad9b-f497-4d80-b969-23297e3293cf-inbound7797245929810821792.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f506544c-dedc-4e90-9995-568810fc27d8-inbound5036407250081744970.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac9480f6bf2dbc74c5426e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac96bbf6bf2dbc74c54273",
      playerId: 1257,
      playerName: "Ripan maji ",
      playerNickName: "Ripan",
      dob: "2008-06-01T00:00:00.000Z",
      weight: "48",
      height: "5.3",
      tShirtSize: "m",
      mobile: "8967975825",
      aadharId: "689046981532",
      address: "Joysinghapur \r\nChousal ",
      district: "Bankura ",
      state: "WB",
      pinCode: "722142",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8e67eb9e-6b59-4644-9f42-11240940b19e-inbound2825928381990489337.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/9ce38410-a452-4745-82ca-ef25d1b445f2-inbound719239354951651410.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac96bbf6bf2dbc74c54274",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67ac9c4b8c65fde91ba08c16",
      playerId: 1258,
      playerName: "Mohar chakraborty ",
      playerNickName: "Mantu ",
      dob: "2005-11-04T00:00:00.000Z",
      weight: "60 kg ",
      height: "6 ফুট 10 ইঞ্চি",
      tShirtSize: "m",
      mobile: "7908128362",
      aadharId: "315103791684",
      address: "Sonamukhi",
      district: "Bankura ",
      state: "WB",
      pinCode: "722207",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/2e15f1b6-0ef7-48ef-9526-fb01fe7d8ead-IMG_20241125_120104.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/a935280b-10bf-4f7d-a516-e6e611116cc0-Screenshot_2025-02-12-18-15-05-820_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67ac9c4b8c65fde91ba08c17",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67acca550df05c33b6a624d9",
      playerId: 1259,
      playerName: "Md Arbaz",
      playerNickName: "BABA",
      dob: "2004-03-26T00:00:00.000Z",
      weight: "65",
      height: "5.5",
      tShirtSize: "l",
      mobile: "7478047892",
      aadharId: "430164443456",
      address: "Chunabhatti",
      district: "Adra",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "left",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/54cc9350-3903-4f39-ad8c-90a1c2739ea6-IMG_20250203_194657_326.webp",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5fb4a499-03c2-4705-9f4d-de12f045a24d-IMG_20250203_194657_326.webp",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67acca550df05c33b6a624da",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67acd6339a113cd2d4bce927",
      playerId: 1260,
      playerName: "Sourav Mukherjee ",
      playerNickName: "Lucky ",
      dob: "1997-10-31T00:00:00.000Z",
      weight: "69",
      height: "5.7",
      tShirtSize: "xl",
      mobile: "9679637624",
      aadharId: "258205172134",
      address: "Bagda-Puncha",
      district: "Purulia ",
      state: "WB",
      pinCode: "723151",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/1667e15a-2378-4efc-9745-be4b0c2bede4-1739372646367-01.jpeg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/d8f405a4-e01d-47e7-a0e5-57654645a234-Screenshot_2025-02-12-22-33-51-002_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67acd6339a113cd2d4bce928",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67adec1396e4be1e3c4a79b8",
      playerId: 1261,
      playerName: "Rana Singha ",
      playerNickName: "Rana ",
      dob: "2005-03-06T00:00:00.000Z",
      weight: "70",
      height: "167",
      tShirtSize: "l",
      mobile: "9883385611",
      aadharId: "839652401472",
      address: "Indpur",
      district: "Bankura ",
      state: "WB",
      pinCode: "722121",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/417a6664-d17c-450d-8aa6-f4ba85adde7d-1000300040.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/43eaecd7-cf34-4e97-b2f7-a7cc1fb7c10f-Screenshot_2025-02-13-18-20-17-94_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67adec1396e4be1e3c4a79b9",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aea364cba04c1606dd2046",
      playerId: 1262,
      playerName: "Sarfaraj Seikh ",
      playerNickName: "Sarfaraj ",
      dob: "2003-09-26T00:00:00.000Z",
      weight: "68",
      height: "5ft ,9inch",
      tShirtSize: "l",
      mobile: "6295499699",
      aadharId: "318540896899",
      address: "muradi",
      district: "Purulia ",
      state: "WB",
      pinCode: "723156",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/60e65154-abdd-4eeb-b8d3-e2af7d3fd09d-IMG20250106140831.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/40e3b5c1-dfbd-4ce6-a41b-6b5a9d157871-Screenshot_2025-02-14-07-25-12-95_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aea364cba04c1606dd2047",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aeb648dc61265792cf923d",
      playerId: 1263,
      playerName: "AVJIT ROY ",
      playerNickName: "Apu",
      dob: "2008-05-23T00:00:00.000Z",
      weight: "50",
      height: "5.3",
      tShirtSize: "m",
      mobile: "7029151029",
      aadharId: "362354583710",
      address: "Bagda-Puncha",
      district: "Purulia ",
      state: "WB",
      pinCode: "723151",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/cc33299d-8136-4926-a6da-9a1cfbdd852b-1000502598.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8a0f5d3f-b101-4c7f-ab84-32b5705c952d-Screenshot_2025-02-14-08-42-06-117_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aeb648dc61265792cf923e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aed4a0b857a909c13322b2",
      playerId: 1264,
      playerName: "Santosh Kumar ",
      playerNickName: "Set wet",
      dob: "2004-12-18T00:00:00.000Z",
      weight: "60 kg ",
      height: "5.8",
      tShirtSize: "l",
      mobile: "8789279926",
      aadharId: "729101307468",
      address: "Huchuk Para",
      district: "Purulia ",
      state: "WB",
      pinCode: "723101",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9c6c010d-f893-4e17-849e-b6e58c150f08-IMG-20250214-WA0001.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/735098e3-50b6-48dd-bc03-c6a2b42a7a03-Screenshot_20250214_105243.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aed4a0b857a909c13322b3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aee00e06299e94f946c089",
      playerId: 1265,
      playerName: "Aftab Ansary",
      dob: "2005-12-29T00:00:00.000Z",
      weight: "60",
      height: "167",
      tShirtSize: "l",
      mobile: "9332473760",
      aadharId: "229150529753",
      address: "Jhalda",
      district: "Purulia ",
      state: "WB",
      pinCode: "723202",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a6827fd9-3d8e-46ec-bbce-09938f651cb2-1000053700.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8157641b-708b-4580-8c80-8ed417051c94-Screenshot_2025-02-14-11-46-32-50_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aee00e06299e94f946c08a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aee75cb47252dbc7eaa82c",
      playerId: 1266,
      playerName: "Bikram Gorai",
      playerNickName: "Bikram",
      dob: "2003-10-15T00:00:00.000Z",
      weight: "55",
      height: "5'5",
      tShirtSize: "l",
      mobile: "8617526391",
      aadharId: "461686108005",
      address: "Raghabpur",
      district: "Purulia",
      state: "WB",
      pinCode: "723101",
      playerType: "bowler",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/c38730d7-bdc7-46e6-8f4b-1efaaa6c48bd-20250214_121545.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f78f2b4d-caa0-438b-862d-6dd1826b08fb-IMG-20250214-WA0003.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aee75cb47252dbc7eaa82d",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67aee8c4b47252dbc7eaa832",
      playerId: 1267,
      playerName: "Manotosh Rajwar",
      playerNickName: "MANOTOSH",
      dob: "2000-09-07T00:00:00.000Z",
      weight: "55",
      height: "5'6",
      tShirtSize: "l",
      mobile: "8250309886",
      aadharId: "745135441565",
      address: "Bongabari",
      district: "Purulia ",
      state: "WB",
      pinCode: "723101",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/05bdf421-bcd4-478e-ac71-844222dbdea4-IMG-20250210-WA0018.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/faec86e0-78cc-4580-9caa-ed39aae73626-IMG-20250214-WA0005.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67aee8c4b47252dbc7eaa833",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67af51850185fd76b6deab52",
      playerId: 1268,
      playerName: "Rick Kumbhakar",
      playerNickName: "Rick",
      dob: "2004-08-13T00:00:00.000Z",
      weight: "78",
      height: "5.10",
      tShirtSize: "xl",
      mobile: "8918815298",
      aadharId: "411288061464",
      address: "Gourangdih",
      district: "PURULIA",
      state: "WB",
      pinCode: "723121",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/65be2c4c-dcf4-4516-b013-b59505262090-inbound3642021632341742060.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1680124a-e294-469e-aa35-29086ddd19b6-inbound1702281035179730318.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67af51850185fd76b6deab53",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67af5a733f8b77ea61facd5a",
      playerId: 1269,
      playerName: "Chirag Chakraborty",
      playerNickName: "Chirag",
      dob: "2005-01-13T00:00:00.000Z",
      weight: "55 kj",
      height: "5.4",
      tShirtSize: "m",
      mobile: "06296434748",
      aadharId: "749832597809",
      address: "Amalnager",
      district: "Sonamukhi",
      state: "WB",
      pinCode: "722207",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/6c945e3e-0e2b-487a-9ddc-41f0702430a2-1000022953.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b1584a49-8767-48ce-b0f2-dc233546c416-IMG-20250214-WA0043.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67af5a733f8b77ea61facd5b",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67af663c62326081033331f9",
      playerId: 1270,
      playerName: "Tapash Chandra paul ",
      playerNickName: "Tapash (Chandra)",
      dob: "1994-02-15T00:00:00.000Z",
      weight: "72",
      height: '6"',
      tShirtSize: "xl",
      mobile: "7478153473",
      aadharId: "252614605641",
      address: "Baragram",
      district: "Purulia ",
      state: "WB",
      pinCode: "723103",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4b039e5e-1437-4c31-a2a7-ff5fc1606233-1000033590.webp",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6a8730c8-d840-48dc-a811-340396eb6f78-Screenshot_2025-02-14-21-19-09-10_6012fa4d4ddec268fc5c7112cbb265e7.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67af663c62326081033331fa",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67af66b862326081033331ff",
      playerId: 1271,
      playerName: "Atanu Dhani",
      playerNickName: "Hardik",
      dob: "2004-08-06T00:00:00.000Z",
      weight: "53",
      height: "5.5",
      tShirtSize: "m",
      mobile: "9883979792",
      aadharId: "615953216386",
      address: "Sonamukhi",
      district: "Bankura",
      state: "WB",
      pinCode: "722207",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/cc9f3f93-c009-4f9b-a0df-5edc29de6aea-IMG-20250214-WA0005.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/1030f2b8-e5d3-415f-b161-c208f9766a7b-IMG-20250214-WA0004.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67af66b86232608103333200",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b0210e20bb8fd32448b3b2",
      playerId: 1272,
      playerName: "khurshid Alam ",
      playerNickName: "Babu",
      dob: "2006-03-18T00:00:00.000Z",
      weight: "71",
      height: "5,6",
      tShirtSize: "l",
      mobile: "7047580094",
      aadharId: "2588 4446 4979",
      address: "Balarampur masjid rood ",
      district: "purulia",
      state: "WB",
      pinCode: "723143",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/4cddbd23-d72c-43d3-bc99-cbceda80fb0e-IMG_20230716_194809.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/714b0819-3b21-4a5b-ae6f-7053dcfeb7d9-Screenshot_2025-02-15-10-32-40-689_com.phonepe.app.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b0210e20bb8fd32448b3b3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b03231a4658a2f65fe3b83",
      playerId: 1273,
      playerName: "Ram Bauri",
      playerNickName: "Ram",
      dob: "1985-04-11T00:00:00.000Z",
      weight: "60kg",
      height: "5'5\"",
      tShirtSize: "xxl",
      mobile: "6297421428",
      aadharId: "316456655898",
      address: "Karpur bagan",
      district: "Purulia ",
      state: "WB",
      pinCode: "723101",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/92043fc5-7f9c-49b3-af82-12194cbd7e6e-IMG-20250215-WA0000.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/2f625216-baad-4b7b-910e-5a21fb9a3ab5-Screenshot_2025-02-15-11-47-12-06_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b03231a4658a2f65fe3b84",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b033e6a4658a2f65fe3b89",
      playerId: 1274,
      playerName: "Nripen Deoghoria",
      playerNickName: "Nipen",
      dob: "1994-12-29T00:00:00.000Z",
      weight: "55 kg",
      height: "5'6\"",
      tShirtSize: "xl",
      mobile: "9339443054",
      aadharId: "707411934830",
      address: "Malthore",
      district: "Purulia ",
      state: "WB",
      pinCode: "723126",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9cbb8f4c-2a62-42c9-a3b0-dca0afa00fa5-IMG-20250215-WA0002.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0ee1dea9-805d-46e2-b753-a59039559924-Screenshot_2025-02-15-11-53-09-19_944a2809ea1b4cda6ef12d1db9048ed3.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b033e6a4658a2f65fe3b8a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b08880ff9e7dfc81610fbf",
      playerId: 1275,
      playerName: "Ratnadip Banerjee",
      playerNickName: "Riju",
      dob: "2005-04-02T00:00:00.000Z",
      weight: "68",
      height: "5'9",
      tShirtSize: "l",
      mobile: "9641621441",
      aadharId: "455331322530",
      address: "Nadiha ",
      district: "Purulia",
      state: "WB",
      pinCode: "723126",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e4b12e8e-0434-4862-9d35-ea5ac0722e34-FB_IMG_1739622346501.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/6ef4d069-2076-40b1-9093-90f3703ecdc6-FB_IMG_1739622346501.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b08880ff9e7dfc81610fc0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b088a7ff9e7dfc81610fc5",
      playerId: 1276,
      playerName: "Maruf raja",
      playerNickName: "Maruf",
      dob: "2001-05-12T00:00:00.000Z",
      weight: "70",
      height: "6",
      tShirtSize: "l",
      mobile: "8597228180",
      aadharId: "557364001675",
      address: "Balarampur masjid road ",
      district: "Purulia",
      state: "WB",
      pinCode: "723143",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/5242134c-f408-4ab0-a1cb-1af94d2a14db-IMG-20250215-WA0001.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/0281f437-c451-4fe7-98a7-ae1496c0aaeb-Screenshot_2025-02-15-17-56-22-96_4336b74596784d9a2aa81f87c2016f50.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b088a7ff9e7dfc81610fc6",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b183516269f0342d23139f",
      playerId: 1277,
      playerName: "Sk Abdul sattar ",
      playerNickName: "Sattar ",
      dob: "1996-05-02T00:00:00.000Z",
      weight: "75",
      height: "5.7",
      tShirtSize: "l",
      mobile: "8101854771",
      aadharId: "521813255401",
      address: "Hura",
      district: "Purulia",
      state: "WB",
      pinCode: "723130",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/a4fa0e3f-255a-4e30-8c37-97d609899dda-Screenshot_2025-02-16-11-41-24-970_com.miui.gallery.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/5db59028-0170-4755-b89e-852885e2cf6f-IMG-20250216-WA0003.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b183516269f0342d2313a0",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d11da5e4ffffc7e7c271",
      playerId: 1278,
      playerName: "BIKRAM MAHATO",
      playerNickName: "BIKRAM",
      dob: "2005-07-29T00:00:00.000Z",
      weight: "62",
      height: "5'-6\"",
      tShirtSize: "l",
      mobile: "9002734367",
      aadharId: "931497549946",
      address: "JHALDA",
      district: "PURULIA",
      state: "WB",
      pinCode: "723213",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8c00d6d9-5310-4a11-a5c5-458e01fc1bbc-img-1.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/408e7e39-1ed6-4187-a0f6-e240d13902d2-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d11da5e4ffffc7e7c272",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d211a5e4ffffc7e7c389",
      playerId: 1279,
      playerName: "SUBHOJIT DEOGURIA",
      playerNickName: "GUDDU",
      dob: "1996-03-17T00:00:00.000Z",
      weight: "68",
      height: "5'7",
      tShirtSize: "xl",
      mobile: "7319311311",
      aadharId: "245262274283",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e83e4cf8-93b6-4596-b96a-1836a8d30294-GUDDU.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f587c51c-a49e-4802-915f-655bfb3b82c9-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d211a5e4ffffc7e7c38a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d2afa5e4ffffc7e7c4a2",
      playerId: 1280,
      playerName: "SAYAN KARMAKAR",
      playerNickName: "RIJU",
      dob: "2006-01-14T00:00:00.000Z",
      weight: "56",
      height: "5'-5\"",
      tShirtSize: "l",
      mobile: "8927593546",
      aadharId: "404292477803",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/6e62b1a2-1dca-484c-b676-afd3a595fde9-RIJU.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/86b8f8cb-2f11-4f4a-a000-39820e54c086-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d2afa5e4ffffc7e7c4a3",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d483a5e4ffffc7e7c6d9",
      playerId: 1281,
      playerName: "BIKRAM BAIDYA",
      playerNickName: "BIKI",
      dob: "1998-10-27T00:00:00.000Z",
      weight: "80",
      height: "5'7",
      tShirtSize: "xl",
      mobile: "8637591694",
      aadharId: "505652474698",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "legSpin",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8dbb02c6-0001-4559-847a-3ed675f4ee23-BIKI.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/f04353ea-b533-49d7-b379-9e0c30865f58-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d483a5e4ffffc7e7c6da",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d548a5e4ffffc7e7c7f4",
      playerId: 1282,
      playerName: "JAYANTA KAR",
      playerNickName: "JAYANTA",
      dob: "1985-04-22T00:00:00.000Z",
      weight: "72",
      height: "5'7",
      tShirtSize: "xl",
      mobile: "7001452414",
      aadharId: "915665406817",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/8f09ca1a-022e-4887-b44d-fcee1aa689fc-JAYANTA.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/cce9535e-2e5f-4a21-a813-d80278f26ab0-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d548a5e4ffffc7e7c7f5",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d5e1a5e4ffffc7e7c7fa",
      playerId: 1283,
      playerName: "SANDIP DEOGHURIA",
      playerNickName: "FATIK",
      dob: "1995-02-27T00:00:00.000Z",
      weight: "60",
      height: "5'-5\"",
      tShirtSize: "l",
      mobile: "9735182342",
      aadharId: "713225753267",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/d46be1f0-a85c-4be1-98eb-7f4cf4a8d1af-FATIK.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e37d66e1-8dcd-471c-8f31-b29968093332-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d5e1a5e4ffffc7e7c7fb",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b2d6a2a5e4ffffc7e7ca37",
      playerId: 1284,
      playerName: "FALGUNI MUKHERJEE",
      playerNickName: "FALGUNI",
      dob: "1992-03-28T00:00:00.000Z",
      weight: "82",
      height: "5'-11\"",
      tShirtSize: "xl",
      mobile: "6297292991",
      aadharId: "643142073113",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/08def90f-4376-4613-a402-41b0116df975-FAL.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/b37f6c42-38ef-42dd-8da9-c0e912e1bf3d-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b2d6a2a5e4ffffc7e7ca38",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b3321f541e5a62db4b4b29",
      playerId: 1285,
      playerName: "ANIRUDDHA BAURI",
      playerNickName: "BADAL",
      dob: "1988-04-23T00:00:00.000Z",
      weight: "60",
      height: "5'-5\"",
      tShirtSize: "l",
      mobile: "8637395891",
      aadharId: "689073864309",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/e25274ae-05dd-45f2-bda1-9910ecb22521-BAD.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/e7880fb3-6c1c-488b-b028-3c6b8fe428be-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b3321f541e5a62db4b4b2a",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b332ec541e5a62db4b4e7d",
      playerId: 1286,
      playerName: "RAMESH GARAI",
      playerNickName: "RAMESH",
      dob: "1999-11-30T00:00:00.000Z",
      weight: "60",
      height: "5'-7\"",
      tShirtSize: "xl",
      mobile: "9832884007",
      aadharId: "977602054079",
      address: "BASUDEBPUR",
      district: "BANKURA",
      state: "WB",
      pinCode: "722134",
      playerType: "batsman",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "na",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/9fe37569-f89a-4d60-9ed1-c11513349d0d-WhatsApp%20Image%202025-02-17%20at%2018.26.57_30f8fb76.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/8d4032f8-c20d-450d-90dd-3d89620f9ac6-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b332ec541e5a62db4b4e7e",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b333b0541e5a62db4b4e83",
      playerId: 1287,
      playerName: "RAMESH NARAYAN DEO",
      playerNickName: "RAMESH",
      dob: "2000-01-17T00:00:00.000Z",
      weight: "72",
      height: "5'7",
      tShirtSize: "xl",
      mobile: "9647468993",
      aadharId: "432715891783",
      address: "FULKUSHMA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722162",
      playerType: "battingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/f9e99ba5-4041-442e-a92e-eecea2013a73-WhatsApp%20Image%202025-02-17%20at%2018.33.25_a23abb5c.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/324d0cc3-e2ec-45fd-8f2f-78697d6419eb-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b333b0541e5a62db4b4e84",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b40a43ad722ec81a9987bd",
      playerId: 1288,
      playerName: "SK REJAUL",
      playerNickName: "KHOKON ALI",
      dob: "1991-07-06T00:00:00.000Z",
      weight: "77",
      height: "5'8\"",
      tShirtSize: "xl",
      mobile: "7432810208",
      aadharId: "731434997295",
      address: "BELIATORE",
      district: "BANKURA",
      state: "WB",
      pinCode: "722223",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "yes",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/97cee43d-7c35-4f60-9b3b-6173272e7af5-sk%20rej.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/ed7e5d3d-62ef-45c1-a739-c18de6cbd320-reja.png",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b40a43ad722ec81a9987be",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b483b61a1fbbc9a5fec8bb",
      playerId: 1289,
      playerName: "PRABIR SINGHA",
      playerNickName: "PRABIR",
      dob: "1996-09-09T00:00:00.000Z",
      weight: "62",
      height: "5'7",
      tShirtSize: "l",
      mobile: "7908943068",
      aadharId: "866661357322",
      address: "AMARKANAN",
      district: "BANKURA",
      state: "WB",
      pinCode: "722132",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/07d2c421-e6a0-4aba-a865-8a9f6301c1cf-WhatsApp%20Image%202025-02-18%20at%2018.07.09_c99c2b87.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/17b856ed-affd-4f9a-b852-7270cf2ef2f4-WhatsApp%20Image%202025-02-18%20at%2018.07.09_c99c2b87.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b483b61a1fbbc9a5fec8bc",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
    {
      _id: "67b4847e1a1fbbc9a5fec8c1",
      playerId: 1290,
      playerName: "SURAJUDDIN KHAN",
      dob: "1995-03-04T00:00:00.000Z",
      weight: "62",
      height: "5'-6\"",
      tShirtSize: "l",
      mobile: "7319394507",
      aadharId: "707779736365",
      address: "CHHATNA",
      district: "BANKURA",
      state: "WB",
      pinCode: "722123",
      playerType: "bowlingAllRounder",
      battingArm: "right",
      bowlingArm: "right",
      bowlingPace: "pace",
      wicketKeeper: "no",
      photo:
        "https://busa-application.s3.amazonaws.com/profilePhoto/7dd479e5-f4bd-4a01-874c-444245958f8a-SU.jpg",
      year: "2025",
      tournaments: [
        {
          league: "lalmatir_cricket_league",
          season: "s1",
          uploadPaymentProof:
            "https://busa-application.s3.amazonaws.com/paymentProof/lalmatir_cricket_league/s1/4adfd3be-eb95-41cb-ad1a-b89e6521f5b7-SU.jpg",
          paymentVerified: true,
          auctionStatus: "",
          soldTeam: "",
          basePrice: "800",
          soldPrice: "",
          _id: "67b4847e1a1fbbc9a5fec8c2",
        },
      ],
      isDeleted: false,
      __v: 0,
    },
  ],
  status: 200,
  statusText: "",
  headers: {
    "content-type": "application/json; charset=utf-8",
  },
  config: {
    transitional: {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false,
    },
    adapter: ["xhr", "http", "fetch"],
    transformRequest: [null],
    transformResponse: [null],
    timeout: 60000,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {},
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    baseURL: "https://busa-server-0p4d.onrender.com",
    method: "get",
    url: "/api/players",
  },
  request: {},
};
